import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { LocalStorage } from "ngx-store";
import { AdminService } from "../../service/admin.service";
import { UserService } from "../../service/user.service";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import * as _ from "lodash";
import * as XLSX from "xlsx";
import moment from "moment";
import { MatDialog } from "@angular/material/dialog";
import { LoadingDialog } from "../dialogs/loading/loading.dialog";

@Component({
  selector: "admin-area",
  templateUrl: "./admin-area.component.html",
  styleUrls: ["./admin-area.component.css"],
})
export class AdminAreaComponent implements OnInit {
  constructor(
    private router: Router,
    private adminService: AdminService,
    private userService: UserService,
    private dialog: MatDialog
  ) {
    if (this.loggedUser && this.userData) {
      this.isLogged = true;
    }
    if (this.isAlsoAdmin) {
      this.isAdmin = true;
      this.adminNickName =
        "@" + this.userData.email.split("@")[0].replace(/\./g, "");
    }
  }

  panelOpenState = false;

  @LocalStorage("loggedUser") loggedUser: any;
  @LocalStorage("userData") userData: any;
  @LocalStorage("isAlsoAdmin") isAlsoAdmin: boolean;

  isLogged = false;
  isAdmin = false;
  adminNickName: string;
  activeUsers = [];
  noVoucherUsers = [];
  admins = [];
  activeUsersShown = [];
  attemptsList = [];
  selectedTask = "Covid";
  showAttemptSelector = false;
  selectedAttempt = 0;
  selectedFilterByTask = "AllUsers";
  newDataAvailable = false;
  pooledActiveUsers = [];
  checkedUsers = [];
  notifiedUsers = [];
  words = [];
  allUsersIdEmail = [];
  subjectId = [];
  blockedUsers = [];
  blockedUsersShown: any[];
  factors = [];
  factorDataRaw = [];
  factorDataRawNomalized = [];
  MDS = [];
  typingTimer: any;
  // =======================
  // <== LOOKUP CACHES ==>
  // =======================
  private adminEmailSet: Set<string> = new Set();
  private noVoucherEmailSet: Set<string> = new Set();
  private nationByEmailMap: Map<string, string> = new Map();
  private subjectIdByEmailMap: Map<string, string> = new Map();
  private emailByUserIdMap: Map<string, string> = new Map();
  private factorsByUserMap: Map<any, any> = new Map();
  private factorDataRawByUserMap: Map<any, any> = new Map();
  private factorDataRawNormalizedByUserMap: Map<any, any> = new Map();
  private mdsByUserMap: Map<any, any> = new Map();
  private wordsByIdMap: Map<any, any> = new Map();
  private blockedEmailSet: Set<string> = new Set();
  private lookupMapsBuilt = false;
  // =======================
  // <==TRANSLATION TOOLS==>
  // =======================

  fileNames = ["General_Translations.xlsx"];
  fileToRead: File | null = null;
  jsonData: any[] = [];
  fileName: string | null = null;

  selectedLanguage: string | null = null;
  updatableLanguages = [
    "en",
    "it",
    "pt",
    "es",
    "fr",
    "el",
    "sq",
    "ru",
    "hi",
    "zh",
    "ar",
    "bn",
    "ur",
    "ko",
    "id",
    "mr",
    "tr",
    "vi",
    "pa",
    "ja",
  ];

  ngOnInit() {
    this.adminService.getSubjectId().then((data: any) => {
      this.subjectId = data.body;
    });

    this.adminService.getAdmins().then((data: any) => {
      this.admins = data.body;
    });
    this.adminService.getUsersIdAndEmail().then((data: any) => {
      this.allUsersIdEmail = data.body;
    });
    this.adminService.getAllWordsAndOld().then((data: any) => {
      this.words = data.body;
    });

    this.adminService.getNoVoucherUsers().then((data: any) => {
      this.noVoucherUsers = data.body;
    });

    this.adminService.getBlockedUsers().then((data: any) => {
      this.blockedUsers = data.body;
    });

    this.adminService.getQuestionnaireDataByType("All").then(() => {});

    this.userService.getFactorAnalysisData().then((data: any) => {
      this.factors = data.body[1];
      this.factorDataRaw = data.body[0];
      this.factorDataRawNomalized = data.body[2];
      this.MDS = data.body[3];
    });

    // Redirect to main page if a NON admin tries to access manually admin-area
    if (!(this.isLogged && this.isAdmin)) {
      setTimeout(() => {
        this.router.navigate(["/"]);
      }, 1150);
    } else {
      this.adminService.getCheckedUsers().then((data: any) => {
        this.checkedUsers = data.body;
      });
      this.adminService
        .getAllCompletedTasks()
        .then((data: any) => {
          this.activeUsers = data.body;
          this.activeUsers.sort(
            (u1, u2) => u2.completed_tasks.length - u1.completed_tasks.length
          );
          this.activeUsersShown = this.activeUsers;
          this.blockedUsersShown = this.blockedUsers;

          this.userService.get_notified_users().then((data: any) => {
            this.notifiedUsers = data.body;
          });
        })
        .then(() => {
          setInterval(() => {
            this.adminService.getAllCompletedTasks().then((data: any) => {
              this.pooledActiveUsers = data.body;
              this.pooledActiveUsers.sort(
                (u1, u2) =>
                  u2.completed_tasks.length - u1.completed_tasks.length
              );
              if (!_.isEqual(this.activeUsers, this.pooledActiveUsers)) {
                this.newDataAvailable = true;
              }
            });
          }, 5000);
        });
    }
  }

  // Build fast lookup sets/maps to avoid repeated O(n) scans
  private buildLookupMaps(): void {
    this.adminEmailSet = new Set((this.admins || []).map((a) => a.email));
    this.noVoucherEmailSet = new Set((this.noVoucherUsers || []).map((u) => u.email));
    this.nationByEmailMap = new Map((this.noVoucherUsers || []).map((u) => [u.email, u.nation]));
    this.subjectIdByEmailMap = new Map((this.subjectId || []).map((s) => [s.email, s.subject_id]));
    this.emailByUserIdMap = new Map((this.allUsersIdEmail || []).map((r) => [r.id, r.email]));
    this.wordsByIdMap = new Map((this.words || []).map((w) => [w.id, w]));
    this.blockedEmailSet = new Set((this.blockedUsers || []).map((b) => b.email));

    const toUserMap = (arr: any[]) => {
      const m = new Map();
      if (Array.isArray(arr)) {
        for (const item of arr) {
          if (item && (item.user_id !== undefined || item.uid !== undefined)) {
            const key = item.user_id !== undefined ? item.user_id : item.uid;
            if (!m.has(key)) m.set(key, []);
            m.get(key).push(item);
          }
        }
      }
      return m;
    };
    this.factorsByUserMap = toUserMap(this.factors);
    this.factorDataRawByUserMap = toUserMap(this.factorDataRaw);
    this.factorDataRawNormalizedByUserMap = toUserMap(this.factorDataRawNomalized);
    this.mdsByUserMap = toUserMap(this.MDS);
    this.lookupMapsBuilt = true;
  }

  // Helper function to safely parse response_time_ms values
  safeParseResponseTime(value: any): number | null {
    if (value == null || value === undefined || value === "") {
      return null;
    }
    
    const parsed = typeof value === 'string' ? parseInt(value) : Number(value);
    return isNaN(parsed) ? null : parsed;
  }

  isUserValid(email: string) {
    if (!this.lookupMapsBuilt) this.buildLookupMaps();
    const isAdmin = this.adminEmailSet.has(email);
    const nation = this.userNation(email);
    return !(isAdmin || nation === "EN");
  }

  isUserNoVoucher(email: string) {
    if (!this.lookupMapsBuilt) this.buildLookupMaps();
    return this.noVoucherEmailSet.has(email);
  }

  isUserBlocked(email: string) {
    if (!this.lookupMapsBuilt) this.buildLookupMaps();
    return this.blockedEmailSet.has(email);
  }

  userNation(email: string) {
    if (!this.lookupMapsBuilt) this.buildLookupMaps();
    return this.nationByEmailMap.get(email) || "";
  }

  userSubjectId(email: string) {
    if (!this.lookupMapsBuilt) this.buildLookupMaps();
    return this.subjectIdByEmailMap.get(email) || "-1";
  }

  downloadQuestionnaireData(type: any, userIdForData: any, userEmail: any) {
    const st = [];
    this.adminService
      .getQuestionnaireDataByTypeAndUser(type, userIdForData)
      .then((data: any) => {
        const userData = data.body;
        for (const us in userData) {
          let email = "";
          for (const x in this.allUsersIdEmail) {
            if (userData[us].uid === this.allUsersIdEmail[x].id) {
              email = this.allUsersIdEmail[x].email;
            }
          }
          const voucher = this.isUserNoVoucher(email);
          let sVoucher = "";
          if (voucher === true) {
            sVoucher = "0";
          } else {
            sVoucher = "1";
          }
          const valid = this.isUserValid(email);
          let sValid = "";
          if (valid === true) {
            sValid = "1";
          } else {
            sValid = "0";
          }
          let nat = this.userNation(email);
          if (nat === "") {
            nat = "EN";
          }

          const subId = this.userSubjectId(email);
          const subIdLanguageVoucher = subId + "_" + nat + "_" + sVoucher;

          const ud = {
            uid: userData[us].uid,
            voucher: sVoucher,
            valid: sValid,
            language: nat,
            subId_language_voucher: subIdLanguageVoucher,
            answer: userData[us].answer,
            answer_id: userData[us].answer_id,
            question_id: userData[us].question_id,
            type: userData[us].type,
          };
          st.push(ud);
        }
        this.manageAndDownloadData(st, type, userEmail);
      });
  }

  language_mapping(nation) {
    if (nation === "EN") {
      return "0";
    }
    if (nation === "IT") {
      return "1";
    }
    if (nation === "SP") {
      return "2";
    }
  }

  downloadQuestionnaireDataAll(type: string) {
    const st = [];
    this.adminService
      .getQuestionnaireDataByType(type === "SeverityIndexes" ? "Covid" : type)
      .then((data: any) => {
        const userData = data.body;
        for (const us in userData) {
          let email = "";
          for (const x in this.allUsersIdEmail) {
            if (userData[us].uid === this.allUsersIdEmail[x].id) {
              email = this.allUsersIdEmail[x].email;
            }
          }
          const voucher = this.isUserNoVoucher(email);
          let s_voucher = "";
          if (voucher == true) {
            s_voucher = "0";
          } else {
            s_voucher = "1";
          }
          const valid = this.isUserValid(email);
          let s_valid = "";
          if (valid == true) {
            s_valid = "1";
          } else {
            s_valid = "0";
          }
          let nat = this.userNation(email);
          if (nat == "") {
            nat = "EN";
          }

          const subId = this.userSubjectId(email);
          const subId_language_voucher = subId + "_" + nat + "_" + s_voucher;
          if (
            type === "Covid" ||
            type === "Fatigue" ||
            type === "Quality" ||
            type === "SeverityIndexes"
          ) {
            for (const f in this.factors) {
              if (this.factors[f].user_id === userData[us].uid) {
                for (const fd in this.factorDataRaw) {
                  const { 
                    user_id, 
                    age, 
                    qol_total_score, 
                    qol11, 
                    qol16, 
                    fatigue_total_score, 
                    fatigue8, 
                    fatigue11, 
                    ...rest 
                  } = this.factorDataRaw[fd];
                  if (this.factorDataRaw[fd].user_id === userData[us].uid) {
                    const lcsi1 =
                      this.factorDataRaw[fd].covidq6 +
                      this.factorDataRaw[fd].covidq11_total +
                      this.factorDataRaw[fd].covidq15;
                    const Qol_reversed =
                      112 - this.factorDataRaw[fd].qol_total_score;
                    const lcsi2 =
                      lcsi1 +
                      this.factorDataRaw[fd].fatigue_total_score +
                      Qol_reversed;
                    const ud = {
                      uid: userData[us].uid,
                      voucher: s_voucher,
                      valid: s_valid,
                      language: nat,
                      subId_language_voucher,
                      answer: userData[us].answer,
                      answer_enum_id: userData[us].response_enum_id
                        ? userData[us].response_enum_id
                        : null,
                      answer_id: userData[us].answer_id,
                      question_id: userData[us].question_id,
                      question_no: userData[us].question_no,
                      type: userData[us].type,
                      lc_flag: userData[us].lc_flag,
                      LCSI1: lcsi1,
                      LCSI2: lcsi2,
                      factor1_influenza_symptoms: this.factors[f][1],
                      factor2_gastrointestinal_symptoms: this.factors[f][2],
                      factor3_fatigue_symptoms: this.factors[f][3],
                      factor4_mixed_symptoms: this.factors[f][4],
                      factor5_psychological_symptoms: this.factors[f][5],
                      encoded_covid_answers: {
                        ...rest,
                      },
                    };
                    st.push(ud);
                  }
                }
              }
            }
          } else {
            const ud = {
              uid: userData[us].uid,
              voucher: s_voucher,
              valid: s_valid,
              language: nat,
              subId_language_voucher,
              answer: userData[us].answer,
              answer_id: userData[us].answer_id,
              question_id: userData[us].question_id,
              type: userData[us].type,
              response_enum_id: userData[us].response_enum_id,
              lc_flag: userData[us].lc_flag,
            };

            st.push(ud);
          }
        }

        this.manageAndDownloadData(st, type, " ");
      });
  }

  downloadFA() {
    this.manageAndDownloadData(this.factors, "FactorAnalysisRESULT", " ");
    this.manageAndDownloadData(
      this.factorDataRaw,
      "FactorAnalysisDataRaw",
      " "
    );
    this.manageAndDownloadData(
      this.factorDataRawNomalized,
      "FactorAnalysisDataRawNormalized",
      " "
    );
    this.manageAndDownloadData(this.MDS, "MDS", " ");
  }

  async downloadCharlie() {
    // Prepare caches and show loading dialog
    this.buildLookupMaps();
    const loadingRef = this.dialog.open(LoadingDialog, {
      disableClose: true,
      data: { message: "Preparing Charlie export..." },
    });
    const st = [];
    try {
      const data: any = await this.adminService.getQuestionnaireDataByType("All");
      const userDatas = data.body;
      const userData = userDatas[2];

      for (const us in userData) {
        const uid = userData[us].uid;
        const email = this.emailByUserIdMap.get(uid) || "";
        const voucher = this.isUserNoVoucher(email);
        const s_voucher = voucher ? "0" : "1";
        const valid = this.isUserValid(email);
        const s_valid = valid ? "1" : "0";
        let nat = this.userNation(email);
        if (nat === "") {
          nat = "EN";
        }

        const subId = this.userSubjectId(email);
        const language = this.language_mapping(nat);
        let voucher_language_subId = s_voucher + language + subId;
        if (subId === "-1") {
          voucher_language_subId = "-" + s_voucher + language + "1";
        }
        const ud = {
          email,
          user_id: uid,
          uid: voucher_language_subId,
          voucher: s_voucher,
          valid: s_valid,
          language,
          lc_flag: userData[us].lc_flag,
          country: userData[us].country,
          gender: userData[us].gender,
          age: userData[us].age,
          education: userData[us].education,
          QoL_total_score: userData[us].sumQoL,
          QoL11: userData[us].QoL11,
          QoL16: userData[us].QoL16,
          Fatigue_total_score: userData[us].sumFatigue,
          Fatigue8: userData[us].Fatigue8,
          Fatigue11: userData[us].Fatigue11,
          answer_id: userData[us].answer_id,
          question_id: userData[us].question_id,
          question: userData[us].question,
          answer: userData[us].answer,
          type: userData[us].type,
        };
        st.push(ud);
      }
      const covidq1 = {};
      const covidq2 = {};
      const covidq3 = {};
      const covidq4 = {};
      const covidq40 = {};
      const covidq41 = {};
      const covidq42 = {};
      const covidq43 = {};
      const covidq44 = {};
      const covidq45 = {};
      const covidq46 = {};
      const covidq47 = {};
      const covidq48 = {};
      const covidq49 = {};
      const covidq410 = {};
      const covidq411 = {};
      const covidq412 = {};
      const covidq413 = {};
      const covidq4tot = {};
      const covidq5 = {};
      const covidq6 = {};
      const covidq7 = {};
      const covidq8 = {};
      const covidq9 = {};
      const covidq10 = {};
      const covidq11 = {};
      const covidq110 = {};
      const covidq111 = {};
      const covidq112 = {};
      const covidq113 = {};
      const covidq114 = {};
      const covidq115 = {};
      const covidq116 = {};
      const covidq117 = {};
      const covidq118 = {};
      const covidq119 = {};
      const covidq1110 = {};
      const covidq1111 = {};
      const covidq1112 = {};
      const covidq1113 = {};
      const covidq1114 = {};
      const covidq1115 = {};
      const covidq1116 = {};
      const covidq1117 = {};
      const covidq1118 = {};
      const covidq1119 = {};
      const covidq1120 = {};
      const covidq1121 = {};
      const covidq1122 = {};
      const covidq1123 = {};
      const covidq1124 = {};
      const covidq11tot = {};
      const covidq12 = {};
      const covidq13 = {};
      const covidq130 = {};
      const covidq131 = {};
      const covidq132 = {};
      const covidq133 = {};
      const covidq134 = {};
      const covidq135 = {};
      const covidq136 = {};
      const covidq137 = {};
      const covidq138 = {};
      const covidq139 = {};
      const covidq1310 = {};
      const covidq1311 = {};
      const covidq1312 = {};
      const covidq1313 = {};
      const covidq1314 = {};
      const covidq1315 = {};
      const covidq1316 = {};
      const covidq1317 = {};
      const covidq1318 = {};
      const covidq1319 = {};
      const covidq1320 = {};
      const covidq1321 = {};
      const covidq1322 = {};
      const covidq1323 = {};
      const covidq1324 = {};
      const covidq13tot = {};
      const covidq14 = {};
      const covidq15 = {};
      const covidq16 = {};
      const lcsi1 = {};
      const lcsi2 = {};
      const Qol_reversed = {};
      const MT_C = {};
      for (const i in st) {
        covidq1[st[i].user_id] = "NaN";
        covidq2[st[i].user_id] = "NaN";
        covidq3[st[i].user_id] = "NaN";
        covidq4[st[i].user_id] = "NaN";
        covidq40[st[i].user_id] = "0";
        covidq41[st[i].user_id] = "0";
        covidq42[st[i].user_id] = "0";
        covidq43[st[i].user_id] = "0";
        covidq44[st[i].user_id] = "0";
        covidq45[st[i].user_id] = "0";
        covidq46[st[i].user_id] = "0";
        covidq47[st[i].user_id] = "0";
        covidq48[st[i].user_id] = "0";
        covidq49[st[i].user_id] = "0";
        covidq410[st[i].user_id] = "0";
        covidq411[st[i].user_id] = "0";
        covidq412[st[i].user_id] = "0";
        covidq413[st[i].user_id] = "0";
        covidq4tot[st[i].user_id] = 0;
        covidq5[st[i].user_id] = "NaN";
        covidq6[st[i].user_id] = "NaN";
        covidq7[st[i].user_id] = "NaN";
        covidq8[st[i].user_id] = "NaN";
        covidq9[st[i].user_id] = "NaN";
        covidq10[st[i].user_id] = "NaN";
        covidq11[st[i].user_id] = "NaN";
        covidq110[st[i].user_id] = "0";
        covidq111[st[i].user_id] = "0";
        covidq112[st[i].user_id] = "0";
        covidq113[st[i].user_id] = "0";
        covidq114[st[i].user_id] = "0";
        covidq115[st[i].user_id] = "0";
        covidq116[st[i].user_id] = "0";
        covidq117[st[i].user_id] = "0";
        covidq118[st[i].user_id] = "0";
        covidq119[st[i].user_id] = "0";
        covidq1110[st[i].user_id] = "0";
        covidq1111[st[i].user_id] = "0";
        covidq1112[st[i].user_id] = "0";
        covidq1113[st[i].user_id] = "0";
        covidq1114[st[i].user_id] = "0";
        covidq1115[st[i].user_id] = "0";
        covidq1116[st[i].user_id] = "0";
        covidq1117[st[i].user_id] = "0";
        covidq1118[st[i].user_id] = "0";
        covidq1119[st[i].user_id] = "0";
        covidq1120[st[i].user_id] = "0";
        covidq1121[st[i].user_id] = "0";
        covidq1122[st[i].user_id] = "0";
        covidq1123[st[i].user_id] = "0";
        covidq1124[st[i].user_id] = "0";
        covidq11tot[st[i].user_id] = 0;
        covidq12[st[i].user_id] = "NaN";
        covidq13[st[i].user_id] = "NaN";
        covidq130[st[i].user_id] = "0";
        covidq131[st[i].user_id] = "0";
        covidq132[st[i].user_id] = "0";
        covidq133[st[i].user_id] = "0";
        covidq134[st[i].user_id] = "0";
        covidq135[st[i].user_id] = "0";
        covidq136[st[i].user_id] = "0";
        covidq137[st[i].user_id] = "0";
        covidq138[st[i].user_id] = "0";
        covidq139[st[i].user_id] = "0";
        covidq1310[st[i].user_id] = "0";
        covidq1311[st[i].user_id] = "0";
        covidq1312[st[i].user_id] = "0";
        covidq1313[st[i].user_id] = "0";
        covidq1314[st[i].user_id] = "0";
        covidq1315[st[i].user_id] = "0";
        covidq1316[st[i].user_id] = "0";
        covidq1317[st[i].user_id] = "0";
        covidq1318[st[i].user_id] = "0";
        covidq1319[st[i].user_id] = "0";
        covidq1320[st[i].user_id] = "0";
        covidq1321[st[i].user_id] = "0";
        covidq1322[st[i].user_id] = "0";
        covidq1323[st[i].user_id] = "0";
        covidq1324[st[i].user_id] = "0";
        covidq13tot[st[i].user_id] = 0;
        covidq14[st[i].user_id] = "NaN";
        covidq15[st[i].user_id] = "NaN";
        covidq16[st[i].user_id] = "NaN";
        lcsi1[st[i].user_id] = 0;
        lcsi2[st[i].user_id] = 0;
        Qol_reversed[st[i].user_id] = 112;
        MT_C[st[i].user_id] = 0;
      }

      for (const i in st) {
        if (st[i].type == "Covid" && st[i].question_id == 1) {
          if (st[i].answer == "Yes, confirmed by a test (any type)") {
            covidq1[st[i].user_id] = "2";
          }
          if (st[i].answer == "Suspected yes but not confirmed by a test") {
            covidq1[st[i].user_id] = "1";
          }
          if (st[i].answer == "No") {
            covidq1[st[i].user_id] = "0";
          }
        }
        if (st[i].type == "Covid" && st[i].question_id == 2) {
          if (st[i].answer == "Yes") {
            covidq2[st[i].user_id] = "1";
          } else {
            covidq2[st[i].user_id] = "0";
          }
        }
        if (st[i].type == "Covid" && st[i].question_id == 3) {
          if (st[i].answer.includes("asymptomatic")) {
            covidq3[st[i].user_id] = "0";
          }
          if (st[i].answer.includes("mild")) {
            covidq3[st[i].user_id] = "1";
          }
          if (st[i].answer.includes("ill")) {
            covidq3[st[i].user_id] = "2";
          }
          if (st[i].answer.includes("but not on ventilator")) {
            covidq3[st[i].user_id] = "3";
          }
          if (st[i].answer.includes("put on a ventilator")) {
            covidq3[st[i].user_id] = "4";
          }
        }
        if (st[i].type == "Covid" && st[i].question_id == 4) {
          covidq4[st[i].user_id] = "";
          const sim = st[i].answer.split(",");

          for (const h in sim) {
            if (sim[h].includes("Dry")) {
              covidq4[st[i].user_id] = covidq4[st[i].user_id] + "0 ";
              covidq40[st[i].user_id] = "1";
              covidq4tot[st[i].user_id] = covidq4tot[st[i].user_id] + 1;
            }
            if (sim[h].includes("Sore")) {
              covidq4[st[i].user_id] = covidq4[st[i].user_id] + "1 ";
              covidq41[st[i].user_id] = "1";
              covidq4tot[st[i].user_id] = covidq4tot[st[i].user_id] + 1;
            }
            if (sim[h].includes("Runny")) {
              covidq4[st[i].user_id] = covidq4[st[i].user_id] + "2 ";
              covidq42[st[i].user_id] = "1";
              covidq4tot[st[i].user_id] = covidq4tot[st[i].user_id] + 1;
            }
            if (sim[h].includes("and/or smell")) {
              covidq4[st[i].user_id] = covidq4[st[i].user_id] + "3 ";
              covidq43[st[i].user_id] = "1";
              covidq4tot[st[i].user_id] = covidq4tot[st[i].user_id] + 1;
            }
            if (sim[h].includes("appetite")) {
              covidq4[st[i].user_id] = covidq4[st[i].user_id] + "4 ";
              covidq44[st[i].user_id] = "1";
              covidq4tot[st[i].user_id] = covidq4tot[st[i].user_id] + 1;
            }
            if (sim[h].includes("Fever")) {
              covidq4[st[i].user_id] = covidq4[st[i].user_id] + "5 ";
              covidq45[st[i].user_id] = "1";
              covidq4tot[st[i].user_id] = covidq4tot[st[i].user_id] + 1;
            }
            if (sim[h].includes("Chills")) {
              covidq4[st[i].user_id] = covidq4[st[i].user_id] + "6 ";
              covidq46[st[i].user_id] = "1";
              covidq4tot[st[i].user_id] = covidq4tot[st[i].user_id] + 1;
            }
            if (sim[h].includes("Headache")) {
              covidq4[st[i].user_id] = covidq4[st[i].user_id] + "7 ";
              covidq47[st[i].user_id] = "1";
              covidq4tot[st[i].user_id] = covidq4tot[st[i].user_id] + 1;
            }
            if (sim[h].includes("Muscle")) {
              covidq4[st[i].user_id] = covidq4[st[i].user_id] + "8 ";
              covidq48[st[i].user_id] = "1";
              covidq4tot[st[i].user_id] = covidq4tot[st[i].user_id] + 1;
            }
            if (sim[h].includes("Fatigue")) {
              covidq4[st[i].user_id] = covidq4[st[i].user_id] + "9 ";
              covidq49[st[i].user_id] = "1";
              covidq4tot[st[i].user_id] = covidq4tot[st[i].user_id] + 1;
            }
            if (sim[h].includes("Shortness")) {
              covidq4[st[i].user_id] = covidq4[st[i].user_id] + "10 ";
              covidq410[st[i].user_id] = "1";
              covidq4tot[st[i].user_id] = covidq4tot[st[i].user_id] + 1;
            }
            if (sim[h].includes("Nausea")) {
              covidq4[st[i].user_id] = covidq4[st[i].user_id] + "11 ";
              covidq411[st[i].user_id] = "1";
              covidq4tot[st[i].user_id] = covidq4tot[st[i].user_id] + 1;
            }
            if (sim[h].includes("Diarrhea")) {
              covidq4[st[i].user_id] = covidq4[st[i].user_id] + "12 ";
              covidq412[st[i].user_id] = "1";
              covidq4tot[st[i].user_id] = covidq4tot[st[i].user_id] + 1;
            }
            if (sim[h].includes("Other")) {
              covidq4[st[i].user_id] = covidq4[st[i].user_id] + "13 ";
              covidq413[st[i].user_id] = "1";
              covidq4tot[st[i].user_id] = covidq4tot[st[i].user_id] + 1;
            }
          }
        }
        if (st[i].type == "Covid" && st[i].question_id == 5) {
          covidq5[st[i].user_id] = st[i].answer;
        }
        if (st[i].type == "Covid" && st[i].question_id == 6) {
          covidq6[st[i].user_id] = st[i].answer;

          if (st[i].answer.includes("Still")) {
            covidq6[st[i].user_id] = "14";
          }

          if (st[i].answer.includes("Longer")) {
            covidq6[st[i].user_id] = "13";
          }
        }
        if (st[i].type == "Covid" && st[i].question_id == 7) {
          if (st[i].answer.includes("fully")) {
            covidq7[st[i].user_id] = "2";
          }
          if (st[i].answer.includes("available")) {
            covidq7[st[i].user_id] = "1";
          }
          if (st[i].answer.includes("No")) {
            covidq7[st[i].user_id] = "0";
          }
        }
        if (st[i].type == "Covid" && st[i].question_id == 8) {
          if (st[i].answer == "Yes") {
            covidq8[st[i].user_id] = "1";
          } else {
            covidq8[st[i].user_id] = "0";
          }
        }
        if (st[i].type == "Covid" && st[i].question_id == 9) {
          if (st[i].answer.includes("confirmed by a")) {
            covidq9[st[i].user_id] = "2";
          }
          if (st[i].answer.includes("suspect")) {
            covidq9[st[i].user_id] = "1";
          }
          if (st[i].answer.includes("No")) {
            covidq9[st[i].user_id] = "0";
          }
        }
        if (st[i].type == "Covid" && st[i].question_id == 10) {
          covidq10[st[i].user_id] = "1";
          if (st[i].answer == "No") {
            covidq10[st[i].user_id] = "0";
          }
        }
        if (st[i].type == "Covid" && st[i].question_id == 11) {
          covidq11[st[i].user_id] = "";
          const sim = st[i].answer.split(",");

          for (const h in sim) {
            if (sim[h].includes("Extreme")) {
              covidq11[st[i].user_id] = covidq11[st[i].user_id] + "0 ";
              covidq110[st[i].user_id] = "1";
              covidq11tot[st[i].user_id] = covidq11tot[st[i].user_id] + 1;
            }
            if (sim[h].includes("Shortness")) {
              covidq11[st[i].user_id] = covidq11[st[i].user_id] + "1 ";
              covidq111[st[i].user_id] = "1";
              covidq11tot[st[i].user_id] = covidq11tot[st[i].user_id] + 1;
            }
            if (sim[h].includes("Chest")) {
              covidq11[st[i].user_id] = covidq11[st[i].user_id] + "2 ";
              covidq112[st[i].user_id] = "1";
              covidq11tot[st[i].user_id] = covidq11tot[st[i].user_id] + 1;
            }
            if (sim[h].includes("memory")) {
              covidq11[st[i].user_id] = covidq11[st[i].user_id] + "3 ";
              covidq113[st[i].user_id] = "1";
              covidq11tot[st[i].user_id] = covidq11tot[st[i].user_id] + 1;
            }
            if (sim[h].includes("concentration")) {
              covidq11[st[i].user_id] = covidq11[st[i].user_id] + "4 ";
              covidq114[st[i].user_id] = "1";
              covidq11tot[st[i].user_id] = covidq11tot[st[i].user_id] + 1;
            }
            if (sim[h].includes("insomnia")) {
              covidq11[st[i].user_id] = covidq11[st[i].user_id] + "5 ";
              covidq115[st[i].user_id] = "1";
              covidq11tot[st[i].user_id] = covidq11tot[st[i].user_id] + 1;
            }
            if (sim[h].includes("palpitations")) {
              covidq11[st[i].user_id] = covidq11[st[i].user_id] + "6 ";
              covidq116[st[i].user_id] = "1";
              covidq11tot[st[i].user_id] = covidq11tot[st[i].user_id] + 1;
            }
            if (sim[h].includes("Dizziness")) {
              covidq11[st[i].user_id] = covidq11[st[i].user_id] + "7 ";
              covidq117[st[i].user_id] = "1";
              covidq11tot[st[i].user_id] = covidq11tot[st[i].user_id] + 1;
            }
            if (sim[h].includes("needles")) {
              covidq11[st[i].user_id] = covidq11[st[i].user_id] + "8 ";
              covidq118[st[i].user_id] = "1";
              covidq11tot[st[i].user_id] = covidq11tot[st[i].user_id] + 1;
            }
            if (sim[h].includes("Joint")) {
              covidq11[st[i].user_id] = covidq11[st[i].user_id] + "9 ";
              covidq119[st[i].user_id] = "1";
              covidq11tot[st[i].user_id] = covidq11tot[st[i].user_id] + 1;
            }
            if (sim[h].includes("Depression")) {
              covidq11[st[i].user_id] = covidq11[st[i].user_id] + "10 ";
              covidq1110[st[i].user_id] = "1";
              covidq11tot[st[i].user_id] = covidq11tot[st[i].user_id] + 1;
            }
            if (sim[h].includes("Anxiety")) {
              covidq11[st[i].user_id] = covidq11[st[i].user_id] + "11 ";
              covidq1111[st[i].user_id] = "1";
              covidq11tot[st[i].user_id] = covidq11tot[st[i].user_id] + 1;
            }
            if (sim[h].includes("Tinnitus")) {
              covidq11[st[i].user_id] = covidq11[st[i].user_id] + "12 ";
              covidq1112[st[i].user_id] = "1";
              covidq11tot[st[i].user_id] = covidq11tot[st[i].user_id] + 1;
            }
            if (sim[h].includes("Ear")) {
              covidq11[st[i].user_id] = covidq11[st[i].user_id] + "13 ";
              covidq1113[st[i].user_id] = "1";
              covidq11tot[st[i].user_id] = covidq11tot[st[i].user_id] + 1;
            }
            if (sim[h].includes("Feeling")) {
              covidq11[st[i].user_id] = covidq11[st[i].user_id] + "14 ";
              covidq1114[st[i].user_id] = "1";
              covidq11tot[st[i].user_id] = covidq11tot[st[i].user_id] + 1;
            }
            if (sim[h].includes("diarrhoea")) {
              covidq11[st[i].user_id] = covidq11[st[i].user_id] + "15 ";
              covidq1115[st[i].user_id] = "1";
              covidq11tot[st[i].user_id] = covidq11tot[st[i].user_id] + 1;
            }
            if (sim[h].includes("stomach")) {
              covidq11[st[i].user_id] = covidq11[st[i].user_id] + "16 ";
              covidq1116[st[i].user_id] = "1";
              covidq11tot[st[i].user_id] = covidq11tot[st[i].user_id] + 1;
            }
            if (sim[h].includes("appetite")) {
              covidq11[st[i].user_id] = covidq11[st[i].user_id] + "17 ";
              covidq1117[st[i].user_id] = "1";
              covidq11tot[st[i].user_id] = covidq11tot[st[i].user_id] + 1;
            }
            if (sim[h].includes("temperature")) {
              covidq11[st[i].user_id] = covidq11[st[i].user_id] + "18 ";
              covidq1118[st[i].user_id] = "1";
              covidq11tot[st[i].user_id] = covidq11tot[st[i].user_id] + 1;
            }
            if (sim[h].includes("cough")) {
              covidq11[st[i].user_id] = covidq11[st[i].user_id] + "19 ";
              covidq1119[st[i].user_id] = "1";
              covidq11tot[st[i].user_id] = covidq11tot[st[i].user_id] + 1;
            }
            if (sim[h].includes("headaches")) {
              covidq11[st[i].user_id] = covidq11[st[i].user_id] + "20 ";
              covidq1120[st[i].user_id] = "1";
              covidq11tot[st[i].user_id] = covidq11tot[st[i].user_id] + 1;
            }
            if (sim[h].includes("sore")) {
              covidq11[st[i].user_id] = covidq11[st[i].user_id] + "21 ";
              covidq1121[st[i].user_id] = "1";
              covidq11tot[st[i].user_id] = covidq11tot[st[i].user_id] + 1;
            }
            if (sim[h].includes("sense of smell")) {
              covidq11[st[i].user_id] = covidq11[st[i].user_id] + "22 ";
              covidq1122[st[i].user_id] = "1";
              covidq11tot[st[i].user_id] = covidq11tot[st[i].user_id] + 1;
            }
            if (sim[h].includes("Rashes")) {
              covidq11[st[i].user_id] = covidq11[st[i].user_id] + "23 ";
              covidq1123[st[i].user_id] = "1";
              covidq11tot[st[i].user_id] = covidq11tot[st[i].user_id] + 1;
            }
            if (sim[h].includes("Other ")) {
              covidq11[st[i].user_id] = covidq11[st[i].user_id] + "24 ";
              covidq1124[st[i].user_id] = "1";
              covidq11tot[st[i].user_id] = covidq11tot[st[i].user_id] + 1;
            }
          }
        }
        if (st[i].type == "Covid" && st[i].question_id == 12) {
          covidq12[st[i].user_id] = st[i].answer;
        }
        if (st[i].type == "Covid" && st[i].question_id == 13) {
          covidq13[st[i].user_id] = "";
          const sim = st[i].answer.split(",");

          for (const h in sim) {
            if (sim[h].includes("Extreme")) {
              covidq13[st[i].user_id] = covidq13[st[i].user_id] + "0 ";
              covidq130[st[i].user_id] = "1";
              covidq13tot[st[i].user_id] = covidq13tot[st[i].user_id] + 1;
            }
            if (sim[h].includes("Shortness")) {
              covidq13[st[i].user_id] = covidq13[st[i].user_id] + "1 ";
              covidq131[st[i].user_id] = "1";
              covidq13tot[st[i].user_id] = covidq13tot[st[i].user_id] + 1;
            }
            if (sim[h].includes("Chest")) {
              covidq13[st[i].user_id] = covidq13[st[i].user_id] + "2 ";
              covidq132[st[i].user_id] = "1";
              covidq13tot[st[i].user_id] = covidq13tot[st[i].user_id] + 1;
            }
            if (sim[h].includes("memory")) {
              covidq13[st[i].user_id] = covidq13[st[i].user_id] + "3 ";
              covidq133[st[i].user_id] = "1";
              covidq13tot[st[i].user_id] = covidq13tot[st[i].user_id] + 1;
            }
            if (sim[h].includes("concentration")) {
              covidq13[st[i].user_id] = covidq13[st[i].user_id] + "4 ";
              covidq134[st[i].user_id] = "1";
              covidq13tot[st[i].user_id] = covidq13tot[st[i].user_id] + 1;
            }
            if (sim[h].includes("insomnia")) {
              covidq13[st[i].user_id] = covidq13[st[i].user_id] + "5 ";
              covidq135[st[i].user_id] = "1";
              covidq13tot[st[i].user_id] = covidq13tot[st[i].user_id] + 1;
            }
            if (sim[h].includes("palpitations")) {
              covidq13[st[i].user_id] = covidq13[st[i].user_id] + "6 ";
              covidq136[st[i].user_id] = "1";
              covidq13tot[st[i].user_id] = covidq13tot[st[i].user_id] + 1;
            }
            if (sim[h].includes("Dizziness")) {
              covidq13[st[i].user_id] = covidq13[st[i].user_id] + "7 ";
              covidq137[st[i].user_id] = "1";
              covidq13tot[st[i].user_id] = covidq13tot[st[i].user_id] + 1;
            }
            if (sim[h].includes("needles")) {
              covidq13[st[i].user_id] = covidq13[st[i].user_id] + "8 ";
              covidq138[st[i].user_id] = "1";
              covidq13tot[st[i].user_id] = covidq13tot[st[i].user_id] + 1;
            }
            if (sim[h].includes("Joint")) {
              covidq13[st[i].user_id] = covidq13[st[i].user_id] + "9 ";
              covidq139[st[i].user_id] = "1";
              covidq13tot[st[i].user_id] = covidq13tot[st[i].user_id] + 1;
            }
            if (sim[h].includes("Depression")) {
              covidq13[st[i].user_id] = covidq13[st[i].user_id] + "10 ";
              covidq1310[st[i].user_id] = "1";
              covidq13tot[st[i].user_id] = covidq13tot[st[i].user_id] + 1;
            }
            if (sim[h].includes("Anxiety")) {
              covidq13[st[i].user_id] = covidq13[st[i].user_id] + "11 ";
              covidq1311[st[i].user_id] = "1";
              covidq13tot[st[i].user_id] = covidq13tot[st[i].user_id] + 1;
            }
            if (sim[h].includes("Tinnitus")) {
              covidq13[st[i].user_id] = covidq13[st[i].user_id] + "12 ";
              covidq1312[st[i].user_id] = "1";
              covidq13tot[st[i].user_id] = covidq13tot[st[i].user_id] + 1;
            }
            if (sim[h].includes("Ear")) {
              covidq13[st[i].user_id] = covidq13[st[i].user_id] + "13 ";
              covidq1313[st[i].user_id] = "1";
              covidq13tot[st[i].user_id] = covidq13tot[st[i].user_id] + 1;
            }
            if (sim[h].includes("Feeling")) {
              covidq13[st[i].user_id] = covidq13[st[i].user_id] + "14 ";
              covidq1314[st[i].user_id] = "1";
              covidq13tot[st[i].user_id] = covidq13tot[st[i].user_id] + 1;
            }
            if (sim[h].includes("diarrhoea")) {
              covidq13[st[i].user_id] = covidq13[st[i].user_id] + "15 ";
              covidq1315[st[i].user_id] = "1";
              covidq13tot[st[i].user_id] = covidq13tot[st[i].user_id] + 1;
            }
            if (sim[h].includes("stomach")) {
              covidq13[st[i].user_id] = covidq13[st[i].user_id] + "16 ";
              covidq1316[st[i].user_id] = "1";
              covidq13tot[st[i].user_id] = covidq13tot[st[i].user_id] + 1;
            }
            if (sim[h].includes("appetite")) {
              covidq13[st[i].user_id] = covidq13[st[i].user_id] + "17 ";
              covidq1317[st[i].user_id] = "1";
              covidq13tot[st[i].user_id] = covidq13tot[st[i].user_id] + 1;
            }
            if (sim[h].includes("temperature")) {
              covidq13[st[i].user_id] = covidq13[st[i].user_id] + "18 ";
              covidq1318[st[i].user_id] = "1";
              covidq13tot[st[i].user_id] = covidq13tot[st[i].user_id] + 1;
            }
            if (sim[h].includes("cough")) {
              covidq13[st[i].user_id] = covidq13[st[i].user_id] + "19 ";
              covidq1319[st[i].user_id] = "1";
              covidq13tot[st[i].user_id] = covidq13tot[st[i].user_id] + 1;
            }
            if (sim[h].includes("headaches")) {
              covidq13[st[i].user_id] = covidq13[st[i].user_id] + "20 ";
              covidq1320[st[i].user_id] = "1";
              covidq13tot[st[i].user_id] = covidq13tot[st[i].user_id] + 1;
            }
            if (sim[h].includes("sore")) {
              covidq13[st[i].user_id] = covidq13[st[i].user_id] + "21 ";
              covidq1321[st[i].user_id] = "1";
              covidq13tot[st[i].user_id] = covidq13tot[st[i].user_id] + 1;
            }
            if (sim[h].includes("sense of smell")) {
              covidq13[st[i].user_id] = covidq13[st[i].user_id] + "22 ";
              covidq1322[st[i].user_id] = "1";
              covidq13tot[st[i].user_id] = covidq13tot[st[i].user_id] + 1;
            }
            if (sim[h].includes("Rashes")) {
              covidq13[st[i].user_id] = covidq13[st[i].user_id] + "23 ";
              covidq1323[st[i].user_id] = "1";
              covidq13tot[st[i].user_id] = covidq13tot[st[i].user_id] + 1;
            }
            if (sim[h].includes("Other ")) {
              covidq13[st[i].user_id] = covidq13[st[i].user_id] + "24 ";
              covidq1324[st[i].user_id] = "1";
              covidq13tot[st[i].user_id] = covidq13tot[st[i].user_id] + 1;
            }
          }
        }
        if (st[i].type == "Covid" && st[i].question_id == 14) {
          covidq14[st[i].user_id] = st[i].answer;
        }
        if (st[i].type == "Covid" && st[i].question_id == 15) {
          if (st[i].answer.includes("no limitations")) {
            covidq15[st[i].user_id] = "0";
          }
          if (st[i].answer.includes("negligible")) {
            covidq15[st[i].user_id] = "1";
          }
          if (st[i].answer.includes("need to spread")) {
            covidq15[st[i].user_id] = "2";
          }
          if (st[i].answer.includes("without any assistance")) {
            covidq15[st[i].user_id] = "3";
          }
          if (st[i].answer.includes("severe limitations")) {
            covidq15[st[i].user_id] = "4";
          }
        }
        if (st[i].type == "Covid" && st[i].question_id == 16) {
          covidq16[st[i].user_id] = st[i].answer;
        }
      }

      const st1 = [];

      for (const us in st) {
        let country = 0;
        if (st[us].country.includes("United Kingdom")) {
          country = 1;
        }
        if (st[us].country.includes("Brazil")) {
          country = 2;
        }
        if (st[us].country.includes("Spain")) {
          country = 3;
        }
        if (st[us].country.includes("South Africa")) {
          country = 4;
        }
        if (st[us].country.includes("Egypt")) {
          country = 5;
        }
        if (st[us].country.includes("Germany")) {
          country = 6;
        }
        if (st[us].country.includes("USA")) {
          country = 7;
        }
        if (st[us].country.includes("Greece")) {
          country = 8;
        }
        if (st[us].country.includes("Poland")) {
          country = 9;
        }
        if (st[us].country.includes("Norway")) {
          country = 10;
        }
        if (st[us].country.includes("Ireland")) {
          country = 11;
        }
        if (st[us].country.includes("Canada")) {
          country = 12;
        }
        let gender = 0;
        if (st[us].gender.includes("Female")) {
          gender = 1;
        }
        const ud = {
          email: st[us].email,
          user_id: st[us].user_id,
          uid: st[us].uid,
          voucher: st[us].voucher,
          valid: st[us].valid,
          language: st[us].language,
          lc_flag:
            st[us].lc_flag !== undefined && st[us].lc_flag !== null
              ? st[us].lc_flag
                ? "True"
                : "False"
              : "Null",
          country,
          gender,
          age: st[us].age,
          education: st[us].education,
          CovidQ1: covidq1[st[us].user_id],
          CovidQ2: covidq2[st[us].user_id],
          CovidQ3: covidq3[st[us].user_id],
          CovidQ4: covidq4[st[us].user_id],
          CovidQ5: covidq5[st[us].user_id],
          CovidQ6: covidq6[st[us].user_id],
          CovidQ7: covidq7[st[us].user_id],
          CovidQ8: covidq8[st[us].user_id],
          CovidQ9: covidq9[st[us].user_id],
          CovidQ10: covidq10[st[us].user_id],
          CovidQ11: covidq11[st[us].user_id],
          CovidQ12: covidq12[st[us].user_id],
          CovidQ13: covidq13[st[us].user_id],
          CovidQ14: covidq14[st[us].user_id],
          CovidQ15: covidq15[st[us].user_id],
          CovidQ16: covidq16[st[us].user_id],
          QoL_total_score: st[us].QoL_total_score,
          QoL11: st[us].QoL11,
          QoL16: st[us].QoL16,
          Fatigue_total_score: st[us].Fatigue_total_score,
          Fatigue8: st[us].Fatigue8,
          Fatigue11: st[us].Fatigue11,
        };
        const isAlreadyInSt1 = st1.find(
          (item) => JSON.stringify(item) === JSON.stringify(ud)
        );

        if (!isAlreadyInSt1) {
          st1.push(ud);
        }
      }
      const statistics =
        this.WordCatecorizationStatisticsDataForCharlieTask(userDatas);

      const st2 = [];

      // Build indexes to avoid O(n^2) joins
      const statsByUid = new Map<string, any[]>();
      const statsByBaseUidNoLang1 = new Map<string, any[]>();
      for (const j in statistics) {
        const s = statistics[j];
        const uidStr = String(s.uid);
        if (!statsByUid.has(uidStr)) statsByUid.set(uidStr, []);
        statsByUid.get(uidStr).push(s);
        const parts = uidStr.split("_");
        const base = parts[0];
        const lang = parts[1];
        if (lang != "1") {
          if (!statsByBaseUidNoLang1.has(base)) statsByBaseUidNoLang1.set(base, []);
          statsByBaseUidNoLang1.get(base).push(s);
        }
      }

      for (const us in st1) {
        for (const j in statistics) {
          let ud = {};
          if (st1[us].user_id == statistics[j].uid) {
            let age = 0;
            if (st1[us].age.includes("18")) {
              age = 1;
            }
            if (st1[us].age.includes("25")) {
              age = 2;
            }
            if (st1[us].age.includes("35")) {
              age = 3;
            }
            if (st1[us].age.includes("45")) {
              age = 4;
            }
            if (st1[us].age.includes("55")) {
              age = 5;
            }
            if (st1[us].age.includes("65")) {
              age = 6;
            }
            if (st1[us].age.includes("75")) {
              age = 7;
            }
            if (st1[us].age.includes("85")) {
              age = 8;
            }

            let education = "0";
            if (st1[us].education.includes("age 15")) {
              education = "1";
            }
            if (st1[us].education.includes("age 18")) {
              education = "2";
            }
            if (st1[us].education.includes("Undergraduate university degree")) {
              education = "3";
            }
            if (st1[us].education.includes("Postgraduate university degree")) {
              education = "4";
            }
            if (st1[us].education.includes("Further degree")) {
              education = "5";
            }
            if (st1[us].education.includes("Other degree")) {
              education = "5";
            }

            covidq4tot[st1[us].user_id] = 0;

            if (covidq40[st1[us].user_id] == 1) {
              covidq4tot[st1[us].user_id] += 1;
            }
            if (covidq41[st1[us].user_id] == 1) {
              covidq4tot[st1[us].user_id] += 1;
            }
            if (covidq42[st1[us].user_id] == 1) {
              covidq4tot[st1[us].user_id] += 1;
            }
            if (covidq43[st1[us].user_id] == 1) {
              covidq4tot[st1[us].user_id] += 1;
            }
            if (covidq44[st1[us].user_id] == 1) {
              covidq4tot[st1[us].user_id] += 1;
            }
            if (covidq45[st1[us].user_id] == 1) {
              covidq4tot[st1[us].user_id] += 1;
            }
            if (covidq46[st1[us].user_id] == 1) {
              covidq4tot[st1[us].user_id] += 1;
            }
            if (covidq47[st1[us].user_id] == 1) {
              covidq4tot[st1[us].user_id] += 1;
            }
            if (covidq48[st1[us].user_id] == 1) {
              covidq4tot[st1[us].user_id] += 1;
            }
            if (covidq49[st1[us].user_id] == 1) {
              covidq4tot[st1[us].user_id] += 1;
            }
            if (covidq410[st1[us].user_id] == 1) {
              covidq4tot[st1[us].user_id] += 1;
            }
            if (covidq411[st1[us].user_id] == 1) {
              covidq4tot[st1[us].user_id] += 1;
            }
            if (covidq412[st1[us].user_id] == 1) {
              covidq4tot[st1[us].user_id] += 1;
            }
            if (covidq413[st1[us].user_id] == 1) {
              covidq4tot[st1[us].user_id] += 1;
            }

            covidq11tot[st1[us].user_id] = 0;

            if (covidq110[st1[us].user_id] == 1) {
              covidq11tot[st1[us].user_id] += 1;
            }
            if (covidq111[st1[us].user_id] == 1) {
              covidq11tot[st1[us].user_id] += 1;
            }
            if (covidq112[st1[us].user_id] == 1) {
              covidq11tot[st1[us].user_id] += 1;
            }
            if (covidq113[st1[us].user_id] == 1) {
              covidq11tot[st1[us].user_id] += 1;
            }
            if (covidq114[st1[us].user_id] == 1) {
              covidq11tot[st1[us].user_id] += 1;
            }
            if (covidq115[st1[us].user_id] == 1) {
              covidq11tot[st1[us].user_id] += 1;
            }
            if (covidq116[st1[us].user_id] == 1) {
              covidq11tot[st1[us].user_id] += 1;
            }
            if (covidq117[st1[us].user_id] == 1) {
              covidq11tot[st1[us].user_id] += 1;
            }
            if (covidq118[st1[us].user_id] == 1) {
              covidq11tot[st1[us].user_id] += 1;
            }
            if (covidq119[st1[us].user_id] == 1) {
              covidq11tot[st1[us].user_id] += 1;
            }
            if (covidq1110[st1[us].user_id] == 1) {
              covidq11tot[st1[us].user_id] += 1;
            }
            if (covidq1111[st1[us].user_id] == 1) {
              covidq11tot[st1[us].user_id] += 1;
            }
            if (covidq1112[st1[us].user_id] == 1) {
              covidq11tot[st1[us].user_id] += 1;
            }
            if (covidq1113[st1[us].user_id] == 1) {
              covidq11tot[st1[us].user_id] += 1;
            }
            if (covidq1114[st1[us].user_id] == 1) {
              covidq11tot[st1[us].user_id] += 1;
            }
            if (covidq1115[st1[us].user_id] == 1) {
              covidq11tot[st1[us].user_id] += 1;
            }
            if (covidq1116[st1[us].user_id] == 1) {
              covidq11tot[st1[us].user_id] += 1;
            }
            if (covidq1117[st1[us].user_id] == 1) {
              covidq11tot[st1[us].user_id] += 1;
            }
            if (covidq1118[st1[us].user_id] == 1) {
              covidq11tot[st1[us].user_id] += 1;
            }
            if (covidq1119[st1[us].user_id] == 1) {
              covidq11tot[st1[us].user_id] += 1;
            }
            if (covidq1120[st1[us].user_id] == 1) {
              covidq11tot[st1[us].user_id] += 1;
            }
            if (covidq1121[st1[us].user_id] == 1) {
              covidq11tot[st1[us].user_id] += 1;
            }
            if (covidq1122[st1[us].user_id] == 1) {
              covidq11tot[st1[us].user_id] += 1;
            }
            if (covidq1123[st1[us].user_id] == 1) {
              covidq11tot[st1[us].user_id] += 1;
            }
            if (covidq1124[st1[us].user_id] == 1) {
              covidq11tot[st1[us].user_id] += 1;
            }

            covidq13tot[st1[us].user_id] = 0;

            if (covidq130[st1[us].user_id] == 1) {
              covidq13tot[st1[us].user_id] += 1;
            }
            if (covidq131[st1[us].user_id] == 1) {
              covidq13tot[st1[us].user_id] += 1;
            }
            if (covidq132[st1[us].user_id] == 1) {
              covidq13tot[st1[us].user_id] += 1;
            }
            if (covidq133[st1[us].user_id] == 1) {
              covidq13tot[st1[us].user_id] += 1;
            }
            if (covidq134[st1[us].user_id] == 1) {
              covidq13tot[st1[us].user_id] += 1;
            }
            if (covidq135[st1[us].user_id] == 1) {
              covidq13tot[st1[us].user_id] += 1;
            }
            if (covidq136[st1[us].user_id] == 1) {
              covidq13tot[st1[us].user_id] += 1;
            }
            if (covidq137[st1[us].user_id] == 1) {
              covidq13tot[st1[us].user_id] += 1;
            }
            if (covidq138[st1[us].user_id] == 1) {
              covidq13tot[st1[us].user_id] += 1;
            }
            if (covidq139[st1[us].user_id] == 1) {
              covidq13tot[st1[us].user_id] += 1;
            }
            if (covidq1310[st1[us].user_id] == 1) {
              covidq13tot[st1[us].user_id] += 1;
            }
            if (covidq1311[st1[us].user_id] == 1) {
              covidq13tot[st1[us].user_id] += 1;
            }
            if (covidq1312[st1[us].user_id] == 1) {
              covidq13tot[st1[us].user_id] += 1;
            }
            if (covidq1313[st1[us].user_id] == 1) {
              covidq13tot[st1[us].user_id] += 1;
            }
            if (covidq1314[st1[us].user_id] == 1) {
              covidq13tot[st1[us].user_id] += 1;
            }
            if (covidq1315[st1[us].user_id] == 1) {
              covidq13tot[st1[us].user_id] += 1;
            }
            if (covidq1316[st1[us].user_id] == 1) {
              covidq13tot[st1[us].user_id] += 1;
            }
            if (covidq1317[st1[us].user_id] == 1) {
              covidq13tot[st1[us].user_id] += 1;
            }
            if (covidq1318[st1[us].user_id] == 1) {
              covidq13tot[st1[us].user_id] += 1;
            }
            if (covidq1319[st1[us].user_id] == 1) {
              covidq13tot[st1[us].user_id] += 1;
            }
            if (covidq1320[st1[us].user_id] == 1) {
              covidq13tot[st1[us].user_id] += 1;
            }
            if (covidq1321[st1[us].user_id] == 1) {
              covidq13tot[st1[us].user_id] += 1;
            }
            if (covidq1322[st1[us].user_id] == 1) {
              covidq13tot[st1[us].user_id] += 1;
            }
            if (covidq1323[st1[us].user_id] == 1) {
              covidq13tot[st1[us].user_id] += 1;
            }
            if (covidq1324[st1[us].user_id] == 1) {
              covidq13tot[st1[us].user_id] += 1;
            }
            let cq6 = parseInt(st1[us].CovidQ6);
            let cq15 = parseInt(st1[us].CovidQ15);
            if (isNaN(cq6)) {
              cq6 = 0;
            }
            if (isNaN(cq15)) {
              cq15 = 0;
            }
            lcsi1[st[us].user_id] = cq6 + covidq11tot[st1[us].user_id] + cq15;

            Qol_reversed[st[us].user_id] = 112 - st1[us].QoL_total_score;

            lcsi2[st[us].user_id] =
              lcsi1[st[us].user_id] +
              st1[us].Fatigue_total_score +
              Qol_reversed[st[us].user_id];

            MT_C[st[us].user_id] = statistics[j].MT_IC + statistics[j].MT_EC;
            for (const f in this.factors) {
              if (this.factors[f].user_id == st1[us].user_id) {
                ud = {
                  email: st1[us].email,
                  user_id: st1[us].user_id,
                  uid: st1[us].uid,
                  voucher: st1[us].voucher,
                  valid: st1[us].valid,
                  language: st1[us].language,
                  lc_flag:
                    st1[us].lc_flag !== undefined && st1[us].lc_flag !== null
                      ? st1[us].lc_flag
                        ? "True"
                        : "False"
                      : "Null",
                  country: st1[us].country,
                  gender: st1[us].gender,
                  age,
                  education,
                  CovidQ1: st1[us].CovidQ1,
                  CovidQ2: st1[us].CovidQ2,
                  CovidQ3: st1[us].CovidQ3,
                  CovidQ4: st1[us].CovidQ4,
                  "CovidQ4: Dry continuous cough": covidq40[st1[us].user_id],
                  "CovidQ4: Sore throat": covidq41[st1[us].user_id],
                  "CovidQ4: Runny nose and/or nasal congestion":
                    covidq42[st1[us].user_id],
                  "CovidQ4: Loss of taste and/or smell":
                    covidq43[st1[us].user_id],
                  "CovidQ4: Loss of appetite": covidq44[st1[us].user_id],
                  "CovidQ4: Fever": covidq45[st1[us].user_id],
                  "CovidQ4: Chills": covidq46[st1[us].user_id],
                  "CovidQ4: Headache": covidq47[st1[us].user_id],
                  "CovidQ4: Muscle or other body aches":
                    covidq48[st1[us].user_id],
                  "CovidQ4: Fatigue": covidq49[st1[us].user_id],
                  "CovidQ4: Shortness of breath/ difficulty breathing":
                    covidq410[st1[us].user_id],
                  "CovidQ4: Nausea and/or vomiting": covidq411[st1[us].user_id],
                  "CovidQ4: Diarrhea": covidq412[st1[us].user_id],
                  "CovidQ4: Other": covidq413[st1[us].user_id],
                  "CovidQ4: Tot": covidq4tot[st1[us].user_id],
                  CovidQ5: st1[us].CovidQ5,
                  CovidQ6: st1[us].CovidQ6,
                  CovidQ7: st1[us].CovidQ7,
                  CovidQ8: st1[us].CovidQ8,
                  CovidQ9: st1[us].CovidQ9,
                  CovidQ10: st1[us].CovidQ10,
                  CovidQ11: st1[us].CovidQ11,
                  "CovidQ11: Extreme tiredness (fatigue)":
                    covidq110[st1[us].user_id],
                  "CovidQ11: Shortness of breath": covidq111[st1[us].user_id],
                  "CovidQ11: Chest pain or tightness":
                    covidq112[st1[us].user_id],
                  "CovidQ11: Problems with memory": covidq113[st1[us].user_id],
                  "CovidQ11: Problems with concentration":
                    covidq114[st1[us].user_id],
                  "CovidQ11: Difficulties sleeping (insomnia)":
                    covidq115[st1[us].user_id],
                  "CovidQ11: Difficulties  Heart palpitations":
                    covidq116[st1[us].user_id],
                  "CovidQ11: Dizziness": covidq117[st1[us].user_id],
                  "CovidQ11: Pins and needles": covidq118[st1[us].user_id],
                  "CovidQ11: Joint pain": covidq119[st1[us].user_id],
                  "CovidQ11: Depression": covidq1110[st1[us].user_id],
                  "CovidQ11: Anxiety": covidq1111[st1[us].user_id],
                  "CovidQ11: Tinnitus": covidq1112[st1[us].user_id],
                  "CovidQ11: Ear ache": covidq1113[st1[us].user_id],
                  "CovidQ11: Feeling sick": covidq1114[st1[us].user_id],
                  "CovidQ11: diarrhoea": covidq1115[st1[us].user_id],
                  "CovidQ11: stomach aches": covidq1116[st1[us].user_id],
                  "CovidQ11: loss of appetite": covidq1117[st1[us].user_id],
                  "CovidQ11: High temperature": covidq1118[st1[us].user_id],
                  "CovidQ11: cough": covidq1119[st1[us].user_id],
                  "CovidQ11: headaches": covidq1120[st1[us].user_id],
                  "CovidQ11: sore throat": covidq1121[st1[us].user_id],
                  "CovidQ11: changes to sense of smell or taste":
                    covidq1122[st1[us].user_id],
                  "CovidQ11: Rashes": covidq1123[st1[us].user_id],
                  "CovidQ11: Other": covidq1124[st1[us].user_id],
                  "CovidQ11: Tot": covidq11tot[st1[us].user_id],
                  CovidQ12: st1[us].CovidQ12,
                  CovidQ13: st1[us].CovidQ13,
                  "CovidQ13: Extreme tiredness (fatigue)":
                    covidq130[st1[us].user_id],
                  "CovidQ13: Shortness of breath": covidq131[st1[us].user_id],
                  "CovidQ13: Chest pain or tightness":
                    covidq132[st1[us].user_id],
                  "CovidQ13: Problems with memory": covidq133[st1[us].user_id],
                  "CovidQ13: Problems with concentration":
                    covidq134[st1[us].user_id],
                  "CovidQ13: Difficulties sleeping (insomnia)":
                    covidq135[st1[us].user_id],
                  "CovidQ13: Difficulties  Heart palpitations":
                    covidq136[st1[us].user_id],
                  "CovidQ13: Dizziness": covidq137[st1[us].user_id],
                  "CovidQ13: Pins and needles": covidq138[st1[us].user_id],
                  "CovidQ13: Joint pain": covidq139[st1[us].user_id],
                  "CovidQ13: Depression": covidq1310[st1[us].user_id],
                  "CovidQ13: Anxiety": covidq1311[st1[us].user_id],
                  "CovidQ13: Tinnitus": covidq1312[st1[us].user_id],
                  "CovidQ13: Ear ache": covidq1313[st1[us].user_id],
                  "CovidQ13: Feeling sick": covidq1314[st1[us].user_id],
                  "CovidQ13: diarrhoea": covidq1315[st1[us].user_id],
                  "CovidQ13: stomach aches": covidq1316[st1[us].user_id],
                  "CovidQ13: loss of appetite": covidq1317[st1[us].user_id],
                  "CovidQ13: High temperature": covidq1318[st1[us].user_id],
                  "CovidQ13: cough": covidq1319[st1[us].user_id],
                  "CovidQ13: headaches": covidq1320[st1[us].user_id],
                  "CovidQ13: sore throat": covidq1321[st1[us].user_id],
                  "CovidQ13: changes to sense of smell or taste":
                    covidq1322[st1[us].user_id],
                  "CovidQ13: Rashes": covidq1323[st1[us].user_id],
                  "CovidQ13: Other": covidq1324[st1[us].user_id],
                  "CovidQ13: Tot": covidq13tot[st1[us].user_id],
                  CovidQ14: st1[us].CovidQ14,
                  CovidQ15: st1[us].CovidQ15,
                  CovidQ16: st1[us].CovidQ16,
                  QoL_total_score: st1[us].QoL_total_score,
                  QoL11: st1[us].QoL11,
                  QoL16: st1[us].QoL16,
                  Fatigue_total_score: st1[us].Fatigue_total_score,
                  Fatigue8: st1[us].Fatigue8,
                  Fatigue11: st1[us].Fatigue11,
                  WC_CorrAns_RT_mean: statistics[j].WC_CorrAns_RT_mean,
                  WC_CorrAns_RT_SD: statistics[j].WC_CorrAns_RT_SD,
                  WC_correct_answers_percentage:
                    statistics[j].WC_correct_answers_percentage,
                  WC_information: statistics[j].WC_information,
                  WC_information_rate: statistics[j].WC_information_rate,
                  MT_IC: statistics[j].MT_IC,
                  MT_EC: statistics[j].MT_EC,
                  MT_IW: statistics[j].MT_IW,
                  MT_EW: statistics[j].MT_EW,
                  MT_NG: statistics[j].MT_NG,
                  LCSI1: lcsi1[st[us].user_id],
                  LCSI2: lcsi2[st[us].user_id],
                  Qol_reversed: Qol_reversed[st[us].user_id],
                  MT_C: MT_C[st[us].user_id],
                  factor1_influenza_symptoms: this.factors[f][1],
                  factor2_gastrointestinal_symptoms: this.factors[f][2],
                  factor3_fatigue_symptoms: this.factors[f][3],
                  factor4_mixed_symptoms: this.factors[f][4],
                  factor5_psychological_symptoms: this.factors[f][5],
                };
                st2.push(ud);
              }
            }
          }
        }
      }

      for (const us in st1) {
        for (const j in statistics) {
          let ud = {};
          if (
            st1[us].user_id.split("_")[0] == statistics[j].uid.split("_")[0] &&
            statistics[j].uid.split("_")[1] != "1"
          ) {
            let age = 0;
            if (st1[us].age.includes("18")) {
              age = 1;
            }
            if (st1[us].age.includes("25")) {
              age = 2;
            }
            if (st1[us].age.includes("35")) {
              age = 3;
            }
            if (st1[us].age.includes("45")) {
              age = 4;
            }
            if (st1[us].age.includes("55")) {
              age = 5;
            }
            if (st1[us].age.includes("65")) {
              age = 6;
            }
            if (st1[us].age.includes("75")) {
              age = 7;
            }
            if (st1[us].age.includes("85")) {
              age = 8;
            }

            let education = "0";
            if (st1[us].education.includes("age 15")) {
              education = "1";
            }
            if (st1[us].education.includes("age 18")) {
              education = "2";
            }
            if (st1[us].education.includes("Undergraduate university degree")) {
              education = "3";
            }
            if (st1[us].education.includes("Postgraduate university degree")) {
              education = "4";
            }
            if (st1[us].education.includes("Further degree")) {
              education = "5";
            }
            if (st1[us].education.includes("Other degree")) {
              education = "5";
            }

            MT_C[st[us].user_id] = statistics[j].MT_IC + statistics[j].MT_EC;
            for (const f in this.factors) {
              if (this.factors[f].user_id == st1[us].user_id) {
                ud = {
                  email: st1[us].email,
                  user_id: statistics[j].uid,
                  uid: st1[us].uid,
                  voucher: st1[us].voucher,
                  valid: st1[us].valid,
                  language: st1[us].language,
                  lc_flag:
                    st1[us].lc_flag !== undefined && st1[us].lc_flag !== null
                      ? st1[us].lc_flag
                        ? "True"
                        : "False"
                      : "Null",
                  country: st1[us].country,
                  gender: st1[us].gender,
                  age,
                  education,
                  CovidQ1: "NULL",
                  CovidQ2: "NULL",
                  CovidQ3: "NULL",
                  CovidQ4: "NULL",
                  "CovidQ4: Dry continuous cough": "NULL",
                  "CovidQ4: Sore throat": "NULL",
                  "CovidQ4: Runny nose and/or nasal congestion": "NULL",
                  "CovidQ4: Loss of taste and/or smell": "NULL",
                  "CovidQ4: Loss of appetite": "NULL",
                  "CovidQ4: Fever": "NULL",
                  "CovidQ4: Chills": "NULL",
                  "CovidQ4: Headache": "NULL",
                  "CovidQ4: Muscle or other body aches": "NULL",
                  "CovidQ4: Fatigue": "NULL",
                  "CovidQ4: Shortness of breath/ difficulty breathing": "NULL",
                  "CovidQ4: Nausea and/or vomiting": "NULL",
                  "CovidQ4: Diarrhea": "NULL",
                  "CovidQ4: Other": "NULL",
                  "CovidQ4: Tot": "NULL",
                  CovidQ5: "NULL",
                  CovidQ6: "NULL",
                  CovidQ7: "NULL",
                  CovidQ8: "NULL",
                  CovidQ9: "NULL",
                  CovidQ10: "NULL",
                  CovidQ11: "NULL",
                  "CovidQ11: Extreme tiredness (fatigue)": "NULL",
                  "CovidQ11: Shortness of breath": "NULL",
                  "CovidQ11: Chest pain or tightness": "NULL",
                  "CovidQ11: Problems with memory": "NULL",
                  "CovidQ11: Problems with concentration": "NULL",
                  "CovidQ11: Difficulties sleeping (insomnia)": "NULL",
                  "CovidQ11: Difficulties  Heart palpitations": "NULL",
                  "CovidQ11: Dizziness": "NULL",
                  "CovidQ11: Pins and needles": "NULL",
                  "CovidQ11: Joint pain": "NULL",
                  "CovidQ11: Depression": "NULL",
                  "CovidQ11: Anxiety": "NULL",
                  "CovidQ11: Tinnitus": "NULL",
                  "CovidQ11: Ear ache": "NULL",
                  "CovidQ11: Feeling sick": "NULL",
                  "CovidQ11: diarrhoea": "NULL",
                  "CovidQ11: stomach aches": "NULL",
                  "CovidQ11: loss of appetite": "NULL",
                  "CovidQ11: High temperature": "NULL",
                  "CovidQ11: cough": "NULL",
                  "CovidQ11: headaches": "NULL",
                  "CovidQ11: sore throat": "NULL",
                  "CovidQ11: changes to sense of smell or taste": "NULL",
                  "CovidQ11: Rashes": "NULL",
                  "CovidQ11: Other": "NULL",
                  "CovidQ11: Tot": "NULL",
                  CovidQ12: "NULL",
                  CovidQ13: "NULL",
                  "CovidQ13: Extreme tiredness (fatigue)": "NULL",
                  "CovidQ13: Shortness of breath": "NULL",
                  "CovidQ13: Chest pain or tightness": "NULL",
                  "CovidQ13: Problems with memory": "NULL",
                  "CovidQ13: Problems with concentration": "NULL",
                  "CovidQ13: Difficulties sleeping (insomnia)": "NULL",
                  "CovidQ13: Difficulties  Heart palpitations": "NULL",
                  "CovidQ13: Dizziness": "NULL",
                  "CovidQ13: Pins and needles": "NULL",
                  "CovidQ13: Joint pain": "NULL",
                  "CovidQ13: Depression": "NULL",
                  "CovidQ13: Anxiety": "NULL",
                  "CovidQ13: Tinnitus": "NULL",
                  "CovidQ13: Ear ache": "NULL",
                  "CovidQ13: Feeling sick": "NULL",
                  "CovidQ13: diarrhoea": "NULL",
                  "CovidQ13: stomach aches": "NULL",
                  "CovidQ13: loss of appetite": "NULL",
                  "CovidQ13: High temperature": "NULL",
                  "CovidQ13: cough": "NULL",
                  "CovidQ13: headaches": "NULL",
                  "CovidQ13: sore throat": "NULL",
                  "CovidQ13: changes to sense of smell or taste": "NULL",
                  "CovidQ13: Rashes": "NULL",
                  "CovidQ13: Other": "NULL",
                  "CovidQ13: Tot": "NULL",
                  CovidQ14: "NULL",
                  CovidQ15: "NULL",
                  CovidQ16: "NULL",
                  QoL_total_score: "NULL",
                  QoL11: "NULL",
                  QoL16: "NULL",
                  Fatigue_total_score: "NULL",
                  Fatigue8: "NULL",
                  Fatigue11: "NULL",
                  WC_CorrAns_RT_mean: statistics[j].WC_CorrAns_RT_mean,
                  WC_CorrAns_RT_SD: statistics[j].WC_CorrAns_RT_SD,
                  WC_correct_answers_percentage:
                    statistics[j].WC_correct_answers_percentage,
                  WC_information: statistics[j].WC_information,
                  WC_information_rate: statistics[j].WC_information_rate,
                  MT_IC: statistics[j].MT_IC,
                  MT_EC: statistics[j].MT_EC,
                  MT_IW: statistics[j].MT_IW,
                  MT_EW: statistics[j].MT_EW,
                  MT_NG: statistics[j].MT_NG,
                  LCSI1: "NULL",
                  LCSI2: "NULL",
                  Qol_reversed: "NULL",
                  MT_C: MT_C[st[us].user_id],
                  factor1_influenza_symptoms: "NULL",
                  factor2_gastrointestinal_symptoms: "NULL",
                  factor3_fatigue_symptoms: "NULL",
                  factor4_mixed_symptoms: "NULL",
                  factor5_psychological_symptoms: "NULL",
                };
                st2.push(ud);
              }
            }
          }
        }
      }

      this.manageAndDownloadData(st2, "All", " ");
    } catch (err) {
      alert("Error processing Charlie export. Please try again.");
    } finally {
      loadingRef.close();
    }
  }

  downloadUsersIdAndEmail() {
    const st = [];
    this.adminService.getUsersIdAndEmail().then((data: any) => {
      const userData = data.body;
      for (const us in userData) {
        let email = "";
        for (const x in this.allUsersIdEmail) {
          if (userData[us].id == this.allUsersIdEmail[x].id) {
            email = this.allUsersIdEmail[x].email;
          }
        }
        const voucher = this.isUserNoVoucher(email);
        let s_voucher = "";
        if (voucher == true) {
          s_voucher = "0";
        } else {
          s_voucher = "1";
        }
        const valid = this.isUserValid(email);
        let s_valid = "";
        if (valid == true) {
          s_valid = "1";
        } else {
          s_valid = "0";
        }
        let nat = this.userNation(email);
        if (nat == "") {
          nat = "EN";
        }

        const subId = this.userSubjectId(email);
        const language = this.language_mapping(nat);
        let voucher_language_subId = s_voucher + language + subId;
        if (subId == "-1") {
          voucher_language_subId = "-" + s_voucher + language + "1";
        }
        const isBlocked = this.isUserBlocked(email);
        const s_blocked = isBlocked ? "1" : "0";
        const ud = {
          user_id: userData[us].id,
          voucher_language_subId,
          email: userData[us].email,
          lc_flag: userData[us].lc_flag,
          voucher: s_voucher,
          valid: s_valid,
          language: nat,
          blocked: s_blocked,
          isAdmin: userData[us].isAdmin,
        };
        st.push(ud);
      }

      this.manageAndDownloadData(st, "users_info", " ");
    });
  }

  downloadTaskData(type, user_id_for_data, userEmail) {
    let s_voucher = "";
    let s_valid = "";
    this.adminService
      .getTaskDataByTypeAndUser(type, user_id_for_data)
      .then((data: any) => {
        const userData = data.body;
        for (const us in userData) {
          let email = "";
          for (const x in this.allUsersIdEmail) {
            if (userData[us].uid == this.allUsersIdEmail[x].id) {
              email = this.allUsersIdEmail[x].email;
            }
          }
          const voucher = this.isUserNoVoucher(email);

          if (voucher == true) {
            s_voucher = "0";
          } else {
            s_voucher = "1";
          }
          const valid = this.isUserValid(email);

          if (valid == true) {
            s_valid = "1";
          } else {
            s_valid = "0";
          }
        }
        switch (type) {
          case "MovementPerception":
            const st3 = [];
            for (const us in userData) {
              let email = "";
              for (const x in this.allUsersIdEmail) {
                if (userData[us].user_id == this.allUsersIdEmail[x].id) {
                  email = this.allUsersIdEmail[x].email;
                }
              }
              const voucher = this.isUserNoVoucher(email);

              if (voucher == true) {
                s_voucher = "0";
              } else {
                s_voucher = "1";
              }
              const valid = this.isUserValid(email);
              let s_valid = "";
              if (valid == true) {
                s_valid = "1";
              } else {
                s_valid = "0";
              }
              let nat = this.userNation(email);
              if (nat == "") {
                nat = "EN";
              }
              const subId = this.userSubjectId(email);
              const language = this.language_mapping(nat);
              let voucher_language_subId = s_voucher + language + subId;
              if (subId == "-1") {
                voucher_language_subId = "-" + s_voucher + language + "1";
              }
              const ud = {
                // "index":userData[us].index,
                user_id: voucher_language_subId,
                voucher: s_voucher,
                valid: s_valid,
                language,
                adap_dir: userData[us].adap_dir,
                normal: userData[us].normal,
                response: userData[us].response,
                test_dir: userData[us].test_dir,
                time_ms: userData[us].time_ms,
                timecheck: userData[us].timecheck,
                trial_nr: userData[us].trial_nr,
              };
              st3.push(ud);
            }
            this.manageAndDownloadData(st3, type, " ");
            break;
          case "FlashBeep":
            const st6 = [];
            for (const us in userData) {
              let email = "";
              for (const x in this.allUsersIdEmail) {
                if (userData[us].user_id == this.allUsersIdEmail[x].id) {
                  email = this.allUsersIdEmail[x].email;
                }
              }
              const voucher = this.isUserNoVoucher(email);

              if (voucher == true) {
                s_voucher = "0";
              } else {
                s_voucher = "1";
              }
              const valid = this.isUserValid(email);
              let s_valid = "";
              if (valid == true) {
                s_valid = "1";
              } else {
                s_valid = "0";
              }
              let nat = this.userNation(email);
              if (nat == "") {
                nat = "EN";
              }
              const subId = this.userSubjectId(email);
              const language = this.language_mapping(nat);
              let voucher_language_subId = s_voucher + language + subId;
              if (subId == "-1") {
                voucher_language_subId = "-" + s_voucher + language + "1";
              }
              const ud = {
                user_id: voucher_language_subId,
                voucher: s_voucher,
                valid: s_valid,
                language,
                trial_number: userData[us].trial_number,
                intended_SOA: userData[us].intended_SOA,
                actual_SOA: userData[us].actual_SOA,
                flash_timeStamp: userData[us].flash_timeStamp,
                beep_timeStamp: userData[us].beep_timeStamp,
                response_timeStamp: userData[us].response_timeStamp,
                responded_flashFirst: userData[us].responded_flashFirst,
                audio_source: userData[us].audio_source,
              };

              st6.push(ud);
            }

            this.manageAndDownloadData(st6, type, " ");
            break;
          case "LoudnessPerception":
            const st5 = [];
            for (const us in userData) {
              let email = "";
              for (const x in this.allUsersIdEmail) {
                if (userData[us].user_id == this.allUsersIdEmail[x].id) {
                  email = this.allUsersIdEmail[x].email;
                }
              }
              const voucher = this.isUserNoVoucher(email);

              if (voucher == true) {
                s_voucher = "0";
              } else {
                s_voucher = "1";
              }
              const valid = this.isUserValid(email);
              let s_valid = "";
              if (valid == true) {
                s_valid = "1";
              } else {
                s_valid = "0";
              }
              let nat = this.userNation(email);
              if (nat == "") {
                nat = "EN";
              }

              const subId = this.userSubjectId(email);
              const language = this.language_mapping(nat);
              let voucher_language_subId = s_voucher + language + subId;
              if (subId == "-1") {
                voucher_language_subId = "-" + s_voucher + language + "1";
              }
              const ud = {
                // "index":userData[us].index,
                user_id: voucher_language_subId,
                voucher: s_voucher,
                valid: s_valid,
                language,
                rating_number: userData[us].rating_number,
                rate_loudness: userData[us].rate_loudness,
                audio_source: userData[us].audio_source,
              };
              st5.push(ud);
            }
            this.manageAndDownloadData(st5, type, " ");
            break;
          case "TargetDetection":
            // Backend now returns unified array with record_type field
            const formattedTargetDetectionData = this.formatTargetDetectionCombined(userData);
            this.manageAndDownloadData(formattedTargetDetectionData, type, userEmail);
            break;
          case "WordCategorization":
            const wordsMap = new Map(this.words.map(word => [word.id, word]));
            const emailMap = new Map(this.allUsersIdEmail.map(user => [user.id, user.email]));
            
            const userCache = new Map();
            
            const getUserInfo = (userId: string, email: string) => {
              if (!userCache.has(userId)) {
                const voucher = this.isUserNoVoucher(email);
                const valid = this.isUserValid(email);
                let nat = this.userNation(email);
                if (nat === "") {
                  nat = "EN";
                }
                const subId = this.userSubjectId(email);
                const language = this.language_mapping(nat);
                
                userCache.set(userId, {
                  voucher: voucher ? "0" : "1",
                  valid: valid ? "1" : "0",
                  nation: nat,
                  subId,
                  language: nat,
                  subId_language_voucher: `${subId}_${nat}_${voucher ? "0" : "1"}`,
                  voucher_language_subId: subId === "-1" 
                    ? `-${voucher ? "0" : "1"}${language}1`
                    : `${voucher ? "0" : "1"}${language}${subId}`
                });
              }
              return userCache.get(userId);
            };
            
            const userData0 = [];
            const userDataToShow0 = [];
            let control = 0;
            const v_voucher = {};
            const v_valid = {};
            const v_nation = {};
            const v_subIdLanVoucher = {};
            const v_VouLanSubId = {};
            const user_ids_traker = {};

            for (let i = 0; i < userData[0].length; i++) {
              const record = userData[0][i];
              const u_id = record.user_id;
              
              if (!(u_id in user_ids_traker)) {
                user_ids_traker[u_id] = 1;
              } else {
                user_ids_traker[u_id] = 0;
              }

              const word = wordsMap.get(record.word_id);
              if (word) {
                const email = emailMap.get(record.user_id) || "";
                
                const userInfo = getUserInfo(record.user_id, email);
                
                let is_user_response_correct = "";
                if (
                  (word.correct_response === "YES" && record.response_choice == 1) ||
                  (word.correct_response === "NO" && record.response_choice == 0)
                ) {
                  is_user_response_correct = "yes";
                } else {
                  is_user_response_correct = "no";
                }
                
                const dateString = record.timestamps;
                let differenceInMilliseconds = null;
                if (dateString && dateString.includes("_")) {
                  const [startDateString, endDateString] = dateString.split("_");
                  const startDate = new Date(startDateString);
                  const endDate = new Date(endDateString);
                  
                  // Check if dates are valid
                  if (!isNaN(startDate.getTime()) && !isNaN(endDate.getTime())) {
                    differenceInMilliseconds = endDate.getTime() - startDate.getTime();
                    if (user_ids_traker[u_id] == 1) {
                      differenceInMilliseconds -= 5 * 1000; // minus 5 seconds because there is the pause after the getReady
                    }
                    // Keep as number, don't convert to string here
                  }
                }

                v_voucher[record.user_id] = userInfo.voucher;
                v_valid[record.user_id] = userInfo.valid;
                v_nation[record.user_id] = userInfo.nation;
                v_subIdLanVoucher[record.user_id] = userInfo.subId_language_voucher;
                v_VouLanSubId[record.user_id] = userInfo.voucher_language_subId;

                let response_choice = 0;
                if (record.response_choice == true) {
                  response_choice = 1;
                }
                let correct_response = 0;
                let alive_notalive = NaN;
                let manmade_notmanmade = NaN;
                if (record.word_task == "alive_task") {
                  alive_notalive = 0;
                } else {
                  manmade_notmanmade = 0;
                }

                if (word.correct_response == "YES") {
                  correct_response = 1;
                  if (record.word_task == "alive_task") {
                    alive_notalive = 1;
                  } else {
                    manmade_notmanmade = 1;
                  }
                }

                let iurc = 0;
                if (is_user_response_correct == "yes") {
                  iurc = 1;
                }

                const temp = {
                  user_id: record.user_id,
                  voucher: userInfo.voucher,
                  valid: userInfo.valid,
                  language: userInfo.nation,
                  lc_flag: record.lc_flag,
                  subId_language_voucher: userInfo.subId_language_voucher,
                  response_choice: record.response_choice,
                  timestamps: record.timestamps,
                  word_id: record.word_id,
                  word: word.value,
                  correct_response: word.correct_response,
                  correct_response_item: word.correct_response_item,
                  correct_response_source: word.correct_response_source,
                  word_task: record.word_task,
                  response_time_ms: differenceInMilliseconds,
                  is_user_response_correct,
                };
                
                const temp1 = {
                  user_id: userInfo.voucher_language_subId,
                  voucher: userInfo.voucher,
                  valid: userInfo.valid,
                  language: userInfo.language,
                  lc_flag: record.lc_flag,
                  word: word.value,
                  user_given_response: response_choice,
                  expected_correct_response: correct_response,
                  is_user_response_correct: iurc,
                  alive_notAlive: alive_notalive,
                  manmade_notManmade: manmade_notmanmade,
                  response_time_ms: differenceInMilliseconds,
                };
                
                userData0.push(temp);
                control = 1;
                userDataToShow0.push(temp1);
              }
            }
            
            if (control == 0) {
              const temp = { nodata: "no data" };
              userData0.push(temp);
            }

            const word_frequency_map = new Map();
            
            for (const item of userData0) {
              const key = `${item.user_id}_${item.word}`;
              if (word_frequency_map.has(key)) {
                word_frequency_map.get(key).categorisation_occurrences++;
              } else {
                word_frequency_map.set(key, {
                  u_id: item.user_id,
                  word: item.word,
                  lc_flag: item.lc_flag,
                  categorisation_occurrences: 1,
                  recognition_occurrences: 0,
                });
              }
            }
            
            const userData1 = [];
            const userDataToShow1 = [];
            let control1 = 0;

            for (let i = 0; i < userData[1].length; i++) {
              const record = userData[1][i];
              
              const word = wordsMap.get(record.word_id);
              if (word) {
                const email = emailMap.get(record.user_id) || "";
                
                const userInfo = getUserInfo(record.user_id, email);
                
                v_voucher[record.user_id] = userInfo.voucher;
                v_valid[record.user_id] = userInfo.valid;
                v_nation[record.user_id] = userInfo.nation;
                v_subIdLanVoucher[record.user_id] = userInfo.subId_language_voucher;
                v_VouLanSubId[record.user_id] = userInfo.voucher_language_subId;

                let correct_response = 0;
                if (word.correct_response == "YES") {
                  correct_response = 1;
                }

                let correct_response_source = NaN;
                if (word.correct_response_source == "alive_task") {
                  correct_response_source = 1;
                }
                if (word.correct_response_source == "manmade_task") {
                  correct_response_source = 0;
                }

                let correct_response_item = 0;
                if (word.correct_response_item == "new") {
                  correct_response_item = 1;
                }
                if (word.correct_response_item == null) {
                  if (word.list == "alive_task") {
                    correct_response_source = 1;
                  }
                  if (word.list == "manmade_task") {
                    correct_response_source = 0;
                  }
                }

                const temp = {
                  user_id: record.user_id,
                  voucher: userInfo.voucher,
                  valid: userInfo.valid,
                  language: userInfo.nation,
                  lc_flag: record.lc_flag,
                  subId_language_voucher: userInfo.subId_language_voucher,
                  response_choice_old_new: record.response_choice_old_new,
                  response_choice_source: record.response_choice_source,
                  timestamp_old_new: record.timestamp_old_new,
                  timestamp_source: record.timestamp_source,
                  word_id: record.word_id,
                  word: word.value,
                  correct_response: word.correct_response,
                  correct_response_item: word.correct_response_item,
                  correct_response_source: word.correct_response_source,
                };
                
                const temp1 = {
                  user_id: userInfo.voucher_language_subId,
                  voucher: userInfo.voucher,
                  valid: userInfo.valid,
                  language: userInfo.language,
                  lc_flag: record.lc_flag,
                  word: word.value,
                  given_response_choice_old_new: record.response_choice_old_new,
                  given_response_choice_alive_manmade: record.response_choice_source,
                  wasOld_new: correct_response_item,
                  was_in_alive_manmade_list: correct_response_source,
                };
                
                userData1.push(temp);
                control1 = 1;
                userDataToShow1.push(temp1);
              }
            }
            
            if (control1 == 0) {
              const temp = { nodata: "no data" };
              userData1.push(temp);
            }

            if (control1 == 0) {
              const temp = { nodata: "no data" };
              userData1.push(temp);
            }
            
            for (const item of userData1) {
              const key = `${item.user_id}_${item.word}`;
              if (word_frequency_map.has(key)) {
                word_frequency_map.get(key).recognition_occurrences++;
              } else {
                word_frequency_map.set(key, {
                  u_id: item.user_id,
                  word: item.word,
                  lc_flag: item.lc_flag,
                  categorisation_occurrences: 0,
                  recognition_occurrences: 1,
                });
              }
            }
            
            const word_frequency = Array.from(word_frequency_map.values());

            const stats = {};

            let control2 = 0;
            for (const item in userData0) {
              if (userData0[item].timestamps.includes("_")) {
                control2 = 1;
                const userId = userData0[item].user_id;
                const correctResponse =
                  userData0[item].is_user_response_correct === "yes";

                if (!stats[userId]) {
                  stats[userId] = {
                    reactionTimes: [],
                    totalResponses: 0,
                    correctResponses: 0,
                  };
                }

                stats[userId].totalResponses++;
                if (correctResponse) {
                  stats[userId].correctResponses++;
                  const responseTime = this.safeParseResponseTime(userData0[item].response_time_ms);
                  if (responseTime !== null) {
                    stats[userId].reactionTimes.push(responseTime);
                  }
                }
              } else {
                const userId = userData0[item].user_id;
                const correctResponse =
                  userData0[item].is_user_response_correct === "yes";

                if (!stats[userId]) {
                  stats[userId] = {
                    reactionTimes: [],
                    totalResponses: 0,
                    correctResponses: 0,
                  };
                }

                stats[userId].reactionTimes.push(" ");
                stats[userId].totalResponses++;
                if (correctResponse) {
                  stats[userId].correctResponses++;
                }
              }
            }

            const mean_stdDev = [];

            for (const userId in stats) {
              const totalResponses = stats[userId].totalResponses;
              const correctResponses = stats[userId].correctResponses;
              const accuracyPercentage =
                (correctResponses / totalResponses) * 100;

              if (control2 == 1) {
                const reactionTimes = stats[userId].reactionTimes;
                const mean = this.calculateMean(reactionTimes);
                const stdDev = this.calculateStandardDeviation(reactionTimes);
                mean_stdDev.push({
                  user_id: userId,
                  voucher: v_voucher[userId],
                  valid: v_valid[userId],
                  language: v_nation[userId],
                  subId_language_voucher: v_subIdLanVoucher[userId],
                  vouch_lan_subId: v_VouLanSubId[userId],
                  mean,
                  standard_deviation: stdDev,
                  correct_answers_percentage: accuracyPercentage,
                });
              } else {
                mean_stdDev.push({
                  user_id: userId,
                  voucher: v_voucher[userId],
                  valid: v_valid[userId],
                  language: v_nation[userId],
                  subId_language_voucher: v_subIdLanVoucher[userId],
                  vouch_lan_subId: v_VouLanSubId[userId],
                  mean: "",
                  standard_deviation: "",
                  correct_answers_percentage: accuracyPercentage,
                });
              }
            }
            // statistics on word_recognition
            let IC_0 = 0; // implicit correct
            let EC_0 = 0; // explicit correct
            let IW_0 = 0; // implicit wrong
            let EW_0 = 0; // explicit wrong
            let NG_0 = 0; // not given

            for (const i in word_frequency) {
              for (const j in userData1) {
                if (word_frequency[i].word === userData1[j].word) {
                  if (
                    word_frequency[i].categorisation_occurrences !=
                    word_frequency[i].recognition_occurrences
                  ) {
                    if (userData1[j].response_choice_old_new == 2) {
                      IC_0 += 1;
                    }
                    if (userData1[j].response_choice_old_new == 1) {
                      EC_0 += 1;
                    }
                    if (userData1[j].response_choice_old_new == 4) {
                      IW_0 += 1;
                    }
                    if (userData1[j].response_choice_old_new == 5) {
                      EW_0 += 1;
                    }
                    if (userData1[j].response_choice_old_new == 3) {
                      NG_0 += 1;
                    }
                  }
                  if (
                    word_frequency[i].categorisation_occurrences ==
                    word_frequency[i].recognition_occurrences
                  ) {
                    if (userData1[j].response_choice_old_new == 4) {
                      IC_0 += 1;
                    }
                    if (userData1[j].response_choice_old_new == 5) {
                      EC_0 += 1;
                    }
                    if (userData1[j].response_choice_old_new == 2) {
                      IW_0 += 1;
                    }
                    if (userData1[j].response_choice_old_new == 1) {
                      EW_0 += 1;
                    }
                    if (userData1[j].response_choice_old_new == 3) {
                      NG_0 += 1;
                    }
                  }
                }
              }
            }
            IC_0 = (IC_0 / userData1.length) * 100;
            EC_0 = (EC_0 / userData1.length) * 100;
            IW_0 = (IW_0 / userData1.length) * 100;
            EW_0 = (EW_0 / userData1.length) * 100;
            NG_0 = (NG_0 / userData1.length) * 100;

            const st = [];

            for (const k in mean_stdDev) {
              const t = {
                user_id: mean_stdDev[k].user_id,
                voucher: v_voucher[mean_stdDev[k].user_id],
                valid: v_valid[mean_stdDev[k].user_id],
                language: v_nation[mean_stdDev[k].user_id],
                subId_language_voucher:
                  v_subIdLanVoucher[mean_stdDev[k].user_id],
                vouch_lan_subid: v_VouLanSubId[mean_stdDev[k].user_id],
                mean: mean_stdDev[k].mean,
                standard_deviation: mean_stdDev[k].standard_deviation,
                correct_answers_percentage:
                  mean_stdDev[k].correct_answers_percentage,
                IC: IC_0,
                EC: EC_0,
                IW: IW_0,
                EW: EW_0,
                NG: NG_0,
              };
              st.push(t);
            }

            const react_t = [];
            for (const h in userData0) {
              let contr = 0;
              for (const k in react_t) {
                if (react_t[k].user_id == userData0[h].user_id) {
                  const responseTime = this.safeParseResponseTime(userData0[h].response_time_ms);
                  if (responseTime !== null) {
                    react_t[k].reaction_time_sum += responseTime;
                  }
                  react_t[k].n_reaction_times += 1;
                  contr = 1;
                }
              }
              if (contr == 0) {
                const responseTime = this.safeParseResponseTime(userData0[h].response_time_ms);
                if (responseTime !== null) {
                  react_t.push({
                    user_id: userData0[h].user_id,
                    reaction_time_sum: responseTime,
                    n_reaction_times: 1,
                  });
                }
              }
            }
            const st1 = [];

            for (const k in st) {
              for (const f in react_t) {
                if (react_t[f].user_id === st[k].user_id) {
                  const infRate = this.calculateInfRate(
                    st[k].correct_answers_percentage,
                    react_t[f].reaction_time_sum / react_t[f].n_reaction_times
                  );
                  const information = this.calculateInformation(
                    st[k].correct_answers_percentage
                  );
                  const language = this.language_mapping(
                    v_nation[st[k].user_id]
                  );
                  let mean = st[k].mean;
                  if (st[k].mean == 0) {
                    mean = NaN;
                  }
                  let std = st[k].standard_deviation;
                  if (st[k].standard_deviation == 0) {
                    std = NaN;
                  }
                  const MT_C = st[k].IC + st[k].EC;
                  const t = {
                    // "user_id": st[k].user_id,
                    user_id: v_VouLanSubId[st[k].user_id],
                    voucher: v_voucher[st[k].user_id],
                    valid: v_valid[st[k].user_id],
                    language,
                    WC_CorrAns_RT_mean: mean,
                    WC_CorrAns_RT_SD: std,
                    WC_correct_answers_percentage:
                      st[k].correct_answers_percentage,
                    WC_information: information,
                    WC_information_rate: infRate * 1000,
                    MT_IC: st[k].IC,
                    MT_EC: st[k].EC,
                    MT_IW: st[k].IW,
                    MT_EW: st[k].EW,
                    MT_NG: st[k].NG,
                    MT_C,
                  };
                  st1.push(t);
                }
              }
            }

            const word_frequency_to_show = [];
            for (const w in word_frequency) {
              word_frequency_to_show.push({
                uid: v_VouLanSubId[st[0].user_id],
                voucher: v_voucher[st[0].user_id],
                valid: v_valid[st[0].user_id],
                language: this.language_mapping(v_nation[st[0].user_id]),
                word: word_frequency[w].word,
                categorisation_occurrences:
                  word_frequency[w].categorisation_occurrences,
                recognition_occurrences:
                  word_frequency[w].recognition_occurrences,
              });
            }

            this.downloadCsvZip2(
              userDataToShow0,
              userDataToShow1,
              word_frequency_to_show,
              st1,
              userEmail,
              "word_categorization", // al posto di finalData0 e FinalData1: userData[0] e userData[1]
              "word_categorization",
              "word_recognition",
              "words_frequency_categorization_task",
              "WC_MT_statistics"
            );
            break;
          default:
            this.manageAndDownloadData(userData, type, userEmail);
        }
      });
  }

  // compute information_rate
  calculateInfRate(accuracy, numbers) {
    if (accuracy == 100) {
      return 1 / numbers;
    }

    if (accuracy == 0) {
      return -1 / numbers;
    }
    accuracy = accuracy / 100;
    const isymb =
      Math.sign(accuracy - 0.5) *
      (accuracy * Math.log2(2 * accuracy) +
        (1 - accuracy) * Math.log2(2 * (1 - accuracy)));
    return isymb / numbers;
  }

  calculateInformation(accuracy) {
    if (accuracy == 100) {
      return 1;
    }
    if (accuracy == 0) {
      return -1;
    }
    accuracy = accuracy / 100;
    return (
      Math.sign(accuracy - 0.5) *
      (accuracy * Math.log2(2 * accuracy) +
        (1 - accuracy) * Math.log2(2 * (1 - accuracy)))
    );
  }

  // without accuracy/100
  calculateInfRate2(accuracy, numbers) {
    if (accuracy == 1) {
      if (numbers == 0) {
        return NaN;
      } else {
        return 1 / numbers;
      }
    }

    if (accuracy == 0) {
      if (numbers == 0) {
        return NaN;
      } else {
        return -1 / numbers;
      }
    }
    const isymb =
      Math.sign(accuracy - 0.5) *
      (accuracy * Math.log2(2 * accuracy) +
        (1 - accuracy) * Math.log2(2 * (1 - accuracy)));
    return isymb / numbers;
  }

  calculateInformation2(accuracy) {
    if (accuracy == 1) {
      return 1;
    }
    if (accuracy == 0) {
      return -1;
    }
    return (
      Math.sign(accuracy - 0.5) *
      (accuracy * Math.log2(2 * accuracy) +
        (1 - accuracy) * Math.log2(2 * (1 - accuracy)))
    );
  }

  // calculate mean
  calculateMean(numbers) {
    const sum = numbers.reduce((acc, curr) => acc + curr, 0);
    return sum / numbers.length;
  }

  // calculate stdDev
  calculateStandardDeviation(numbers) {
    const mean = this.calculateMean(numbers);
    const squaredDifferences = numbers.map((num) => (num - mean) ** 2);
    const variance = this.calculateMean(squaredDifferences);
    return Math.sqrt(variance);
  }

  WordCatecorizationStatisticsDataForCharlieTask(userData) {
    const userData0 = [];
    const userDataToShow0 = [];
    let control = 0;
    const v_voucher = {};
    const v_valid = {};
    const v_nation = {};
    const v_subIdLanVoucher = {};
    const v_VouLanSubId = {};
    const user_ids_traker = {};
    let s_voucher = "";
    let s_valid = "";

    for (const i in userData[0]) {
      const u_id = userData[0][i].user_id;
      if (!(u_id in user_ids_traker)) {
        user_ids_traker[u_id] = 1;
      } else {
        user_ids_traker[u_id] = 0;
      }

      const word0 = this.wordsByIdMap.get(userData[0][i].word_id);
      if (word0) {
          let is_user_response_correct = "";
          if (
            (word0.correct_response === "YES" &&
              userData[0][i].response_choice == 1) ||
            (word0.correct_response === "NO" &&
              userData[0][i].response_choice == 0)
          ) {
            is_user_response_correct = "yes";
          } else {
            is_user_response_correct = "no";
          }
          const dateString = userData[0][i].timestamps;
          let differenceInMilliseconds;

          if (dateString.includes("_")) {
            const [startDateString, endDateString] = dateString.split("_");

            const startDate = new Date(startDateString);
            const endDate = new Date(endDateString);

            differenceInMilliseconds = endDate.getTime() - startDate.getTime();
            if (user_ids_traker[u_id] == 1) {
              differenceInMilliseconds -= 5 * 1000; // minus 5 seconds because there is the pause after the getReady
            }
          }
          const email = this.emailByUserIdMap.get(userData[0][i].user_id) || "";
          const voucher = this.isUserNoVoucher(email);

          if (voucher == true) {
            s_voucher = "0";
          } else {
            s_voucher = "1";
          }
          const valid = this.isUserValid(email);
          if (valid == true) {
            s_valid = "1";
          } else {
            s_valid = "0";
          }
          v_voucher[userData[0][i].user_id] = s_voucher;
          v_valid[userData[0][i].user_id] = s_valid;

          let nat = this.userNation(email);
          if (nat == "") {
            nat = "EN";
          }
          v_nation[userData[0][i].user_id] = nat;

          const subId = this.userSubjectId(email);
          const subId_language_voucher = subId + "_" + nat + "_" + s_voucher;
          v_subIdLanVoucher[userData[0][i].user_id] = subId_language_voucher;

          const language = this.language_mapping(nat);
          let voucher_language_subId = s_voucher + language + subId;
          if (subId == "-1") {
            voucher_language_subId = "-" + s_voucher + language + "1";
          }

          v_VouLanSubId[userData[0][i].user_id] = voucher_language_subId;

          let response_choice = 0;
          if (userData[0][i].response_choice == true) {
            response_choice = 1;
          }
          let correct_response = 0;
          let alive_notalive = NaN;
          let manmade_notmanmade = NaN;
          if (userData[0][i].word_task == "alive_task") {
            alive_notalive = 0;
          } else {
            manmade_notmanmade = 0;
          }

          if (word0.correct_response == "YES") {
            correct_response = 1;
            if (userData[0][i].word_task == "alive_task") {
              alive_notalive = 1;
            } else {
              manmade_notmanmade = 1;
            }
          }

          let iurc = 0;
          if (is_user_response_correct == "yes") {
            iurc = 1;
          }

          const temp = {
            // "index": userData[0][i].index,
            user_id: userData[0][i].user_id,
            voucher: s_voucher,
            valid: s_valid,
            language: nat,
            subId_language_voucher,
            response_choice: userData[0][i].response_choice,
            timestamps: userData[0][i].timestamps,
            word_id: userData[0][i].word_id,
            word: word0.value,
            correct_response: word0.correct_response,
            correct_response_item: word0.correct_response_item,
            correct_response_source: word0.correct_response_source,
            word_task: userData[0][i].word_task,
            response_time_ms: differenceInMilliseconds,
            is_user_response_correct,
          };
          if (differenceInMilliseconds == undefined) {
            differenceInMilliseconds = NaN;
          }
          const temp1 = {
            // "index": userData[0][i].index,
            user_id: voucher_language_subId,
            voucher: s_voucher,
            valid: s_valid,
            language,
            word: word0.value,
            user_given_response: response_choice,
            // "timestamps":userData[0][i].timestamps,
            expected_correct_response: correct_response,
            is_user_response_correct: iurc,
            alive_notAlive: alive_notalive,
            manmade_notManmade: manmade_notmanmade,
            // "expected_word_task":word_task,
            response_time_ms: differenceInMilliseconds,
          };
          userData0.push(temp);
          control = 1;
          userDataToShow0.push(temp1);
      }
    }
    if (control == 0) {
      const temp = { nodata: "no data" };
      userData0.push(temp);
    }

    const word_frequency = [];
    for (const i in userData0) {
      let contr = 0;
      for (const j in word_frequency) {
        if (
          word_frequency[j].u_id === userData0[i].user_id &&
          word_frequency[j].word == userData0[i].word
        ) {
          word_frequency[j].categorisation_occurrences =
            word_frequency[j].categorisation_occurrences + 1;
          contr = 1;
        }
      }
      if (contr == 0) {
        word_frequency.push({
          u_id: userData0[i].user_id,
          word: userData0[i].word,
          categorisation_occurrences: 1,
          recognition_occurrences: 0,
        });
      }
    }
    const userData1 = [];
    const userDataToShow1 = [];
    let control1 = 0;

    for (const i in userData[1]) {
      for (const j in this.words) {
        if (userData[1][i].word_id === this.words[j].id) {
          let email = "";
          for (const us in this.allUsersIdEmail) {
            if (this.allUsersIdEmail[us].id == userData[1][i].user_id) {
              email = this.allUsersIdEmail[us].email;
            }
          }
          const voucher = this.isUserNoVoucher(email);

          if (voucher == true) {
            s_voucher = "0";
          } else {
            s_voucher = "1";
          }
          const valid = this.isUserValid(email);
          if (valid == true) {
            s_valid = "1";
          } else {
            s_valid = "0";
          }
          v_voucher[userData[1][i].user_id] = s_voucher;
          v_valid[userData[1][i].user_id] = s_valid;

          let nat = this.userNation(email);
          if (nat == "") {
            nat = "EN";
          }
          v_nation[userData[1][i].user_id] = nat;

          const subId = this.userSubjectId(email);
          const subId_language_voucher = subId + "_" + nat + "_" + s_voucher;
          v_subIdLanVoucher[userData[1][i].user_id] = subId_language_voucher;

          const language = this.language_mapping(nat);
          let voucher_language_subId = s_voucher + language + subId;
          if (subId == "-1") {
            voucher_language_subId = "-" + s_voucher + language + "1";
          }
          v_VouLanSubId[userData[1][i].user_id] = voucher_language_subId;

          let correct_response = 0;
          if (this.words[j].correct_response == "YES") {
            correct_response = 1;
          }

          let correct_response_source = NaN;
          if (this.words[j].correct_response_source == "alive_task") {
            correct_response_source = 1;
          }
          if (this.words[j].correct_response_source == "manmade_task") {
            correct_response_source = 0;
          }

          let correct_response_item = 0;
          if (this.words[j].correct_response_item == "new") {
            correct_response_item = 1;
          }
          if (this.words[j].correct_response_item == null) {
            if (this.words[j].list == "alive_task") {
              correct_response_source = 1;
            }
            if (this.words[j].list == "manmade_task") {
              correct_response_source = 0;
            }
          }

          const temp = {
            // "index":userData[1][i].index,
            user_id: userData[1][i].user_id,
            voucher: s_voucher,
            valid: s_valid,
            language: nat,
            subId_language_voucher,
            response_choice_old_new: userData[1][i].response_choice_old_new,
            response_choice_source: userData[1][i].response_choice_source,
            timestamp_old_new: userData[1][i].timestamp_old_new,
            timestamp_source: userData[1][i].timestamp_source,
            word_id: userData[1][i].word_id,
            word: this.words[j].value,
            correct_response: this.words[j].correct_response,
            correct_response_item: this.words[j].correct_response_item,
            correct_response_source: this.words[j].correct_response_source,
          };
          const temp1 = {
            // "index":userData[1][i].index,
            user_id: voucher_language_subId,
            voucher: s_voucher,
            valid: s_valid,
            language,
            word: this.words[j].value,
            given_response_choice_old_new:
              userData[1][i].response_choice_old_new,
            given_response_choice_alive_manmade:
              userData[1][i].response_choice_source,
            // "timestamp_old_new":userData[1][i].timestamp_old_new,
            // "timestamp_source":userData[1][i].timestamp_source,

            wasOld_new: correct_response_item,
            was_in_alive_manmade_list: correct_response_source,
          };
          userData1.push(temp);
          control1 = 1;
          userDataToShow1.push(temp1);
        }
      }
    }
    if (control1 == 0) {
      const temp = { nodata: "no data" };
      userData1.push(temp);
    }

    if (control1 == 0) {
      const temp = { nodata: "no data" };
      userData1.push(temp);
    }
    const wfMap = new Map(word_frequency.map(w => [`${w.u_id}_${w.word}`, w]));
    for (let i = 0; i < userData1.length; i++) {
      const key = `${userData1[i].user_id}_${userData1[i].word}`;
      if (wfMap.has(key)) {
        wfMap.get(key).recognition_occurrences += 1;
      } else {
        wfMap.set(key, {
          u_id: userData1[i].user_id,
          word: userData1[i].word,
          categorisation_occurrences: 0,
          recognition_occurrences: 1,
        });
      }
    }
    const word_frequency_arr = Array.from(wfMap.values());

    const stats = {};

    let control2 = 0;
    for (const item in userData0) {
      if (userData0[item].timestamps.includes("_")) {
        control2 = 1;
        const userId = userData0[item].user_id;
        const correctResponse =
          userData0[item].is_user_response_correct === "yes";

        if (!stats[userId]) {
          stats[userId] = {
            reactionTimes: [],
            totalResponses: 0,
            correctResponses: 0,
          };
        }

        stats[userId].totalResponses++;
        if (correctResponse) {
          stats[userId].correctResponses++;
          const responseTime = this.safeParseResponseTime(userData0[item].response_time_ms);
          if (responseTime !== null) {
            stats[userId].reactionTimes.push(responseTime);
          }
        }
      } else {
        const userId = userData0[item].user_id;
        const correctResponse =
          userData0[item].is_user_response_correct === "yes";

        if (!stats[userId]) {
          stats[userId] = {
            reactionTimes: [],
            totalResponses: 0,
            correctResponses: 0,
          };
        }

        stats[userId].reactionTimes.push(" ");
        stats[userId].totalResponses++;
        if (correctResponse) {
          stats[userId].correctResponses++;
        }
      }
    }

    const mean_stdDev = [];

    for (const userId in stats) {
      const totalResponses = stats[userId].totalResponses;
      const correctResponses = stats[userId].correctResponses;
      const accuracyPercentage = (correctResponses / totalResponses) * 100;

      if (control2 == 1) {
        const reactionTimes = stats[userId].reactionTimes;
        const mean = this.calculateMean(reactionTimes);
        const stdDev = this.calculateStandardDeviation(reactionTimes);

        mean_stdDev.push({
          user_id: userId,
          voucher: v_voucher[userId],
          valid: v_valid[userId],
          language: v_nation[userId],
          subId_language_voucher: v_subIdLanVoucher[userId],
          mean,
          standard_deviation: stdDev,
          correct_answers_percentage: accuracyPercentage,
        });
      } else {
        mean_stdDev.push({
          user_id: userId,
          voucher: v_voucher[userId],
          valid: v_valid[userId],
          language: v_nation[userId],
          subId_language_voucher: v_subIdLanVoucher[userId],
          mean: "",
          standard_deviation: "",
          correct_answers_percentage: accuracyPercentage,
        });
      }
    }

    const user_ic = {};
    const user_ec = {};
    const user_iw = {};
    const user_ew = {};
    const user_ng = {};
    const user_tot_answ = {};

    for (let i = 0; i < word_frequency_arr.length; i++) {
      user_ic[word_frequency_arr[i].u_id] = 0;
      user_ec[word_frequency_arr[i].u_id] = 0;
      user_iw[word_frequency_arr[i].u_id] = 0;
      user_ew[word_frequency_arr[i].u_id] = 0;
      user_ng[word_frequency_arr[i].u_id] = 0;
      user_tot_answ[word_frequency_arr[i].u_id] = 0;
    }

    const userWordsMap = new Map();
    for (let j = 0; j < userData1.length; j++) {
      const item = userData1[j];
      const key = `${item.user_id}_${item.word}`;
      const wf = wfMap.get(key);
      if (!wf) continue;
      const uid = wf.u_id;
      user_tot_answ[uid] += 1;
      if (wf.categorisation_occurrences != wf.recognition_occurrences) {
        if (item.response_choice_old_new == 2) user_ic[uid] += 1;
        if (item.response_choice_old_new == 1) user_ec[uid] += 1;
        if (item.response_choice_old_new == 4) user_iw[uid] += 1;
        if (item.response_choice_old_new == 5) user_ew[uid] += 1;
        if (item.response_choice_old_new == 3) user_ng[uid] += 1;
      } else {
        if (item.response_choice_old_new == 4) user_ic[uid] += 1;
        if (item.response_choice_old_new == 5) user_ec[uid] += 1;
        if (item.response_choice_old_new == 2) user_iw[uid] += 1;
        if (item.response_choice_old_new == 1) user_ew[uid] += 1;
        if (item.response_choice_old_new == 3) user_ng[uid] += 1;
      }
    }

    for (const g in user_ic) {
      user_ic[g] = (user_ic[g] / user_tot_answ[g]) * 100;
      user_ec[g] = (user_ec[g] / user_tot_answ[g]) * 100;
      user_iw[g] = (user_iw[g] / user_tot_answ[g]) * 100;
      user_ew[g] = (user_ew[g] / user_tot_answ[g]) * 100;
      user_ng[g] = (user_ng[g] / user_tot_answ[g]) * 100;
    }

    const st = [];

    for (const k in mean_stdDev) {
      const t = {
        user_id: mean_stdDev[k].user_id,
        voucher: v_voucher[mean_stdDev[k].user_id],
        valid: v_valid[mean_stdDev[k].user_id],
        language: v_nation[mean_stdDev[k].user_id],
        subId_language_voucher: v_subIdLanVoucher[mean_stdDev[k].user_id],
        mean: mean_stdDev[k].mean,
        standard_deviation: mean_stdDev[k].standard_deviation,
        correct_answers_percentage: mean_stdDev[k].correct_answers_percentage,
        IC: user_ic[mean_stdDev[k].user_id],
        EC: user_ec[mean_stdDev[k].user_id],
        IW: user_iw[mean_stdDev[k].user_id],
        EW: user_ew[mean_stdDev[k].user_id],
        NG: user_ng[mean_stdDev[k].user_id],
      };
      st.push(t);
    }

    const reactMap = new Map();
    for (let h = 0; h < userData0.length; h++) {
      const rec = userData0[h];
      const responseTime = this.safeParseResponseTime(rec.response_time_ms);
      if (responseTime !== null) {
        const existing = reactMap.get(rec.user_id);
        if (existing) {
          existing.reaction_time_sum += responseTime;
          existing.n_reaction_times += 1;
        } else {
          reactMap.set(rec.user_id, {
            user_id: rec.user_id,
            reaction_time_sum: responseTime,
            n_reaction_times: 1,
          });
        }
      }
    }
    const react_t = Array.from(reactMap.values());
    const st1 = [];
    for (const k in st) {
      for (const f in react_t) {
        if (react_t[f].user_id === st[k].user_id) {
          const infRate = this.calculateInfRate(
            st[k].correct_answers_percentage,
            react_t[f].reaction_time_sum / react_t[f].n_reaction_times
          );
          const information = this.calculateInformation(
            st[k].correct_answers_percentage
          );
          let mean = st[k].mean;
          if (st[k].mean == 0) {
            mean = NaN;
          }
          let std = st[k].standard_deviation;
          if (st[k].standard_deviation == 0) {
            std = NaN;
          }
          const t = {
            uid: st[k].user_id,
            user_id: v_VouLanSubId[st[k].user_id],
            voucher: v_voucher[st[k].user_id],
            valid: v_valid[st[k].user_id],
            language: this.language_mapping(v_nation[st[k].user_id]),
            WC_CorrAns_RT_mean: mean,
            WC_CorrAns_RT_SD: std,
            WC_correct_answers_percentage: st[k].correct_answers_percentage,
            WC_information: information,
            WC_information_rate: infRate * 1000,

            // "WC_mean_Rt_tot":react_t[f].reaction_time_sum/react_t[f].n_reaction_times,
            MT_IC: st[k].IC,
            MT_EC: st[k].EC,
            MT_IW: st[k].IW,
            MT_EW: st[k].EW,
            MT_NG: st[k].NG,
          };
          st1.push(t);
        }
      }
    }
    return st1;
  }

  // ============================================================================
  // NEW: Combined formatting function for unified Target Detection data
  // ============================================================================
  formatTargetDetectionCombined(data: any[]): any[] {
    if (!data || data.length === 0) {
      return [];
    }

    // Helper encoding functions
    const encodeUpDown = (val: any) => {
      if (val === null || val === undefined) return val;
      if (typeof val === 'number') return val;
      const str = String(val).toLowerCase();
      if (str.includes('down')) return 0;
      if (str.includes('up')) return 1;
      if (str === 'up') return 1;
      if (str === 'down') return 0;
      if (str === '1') return 1;
      if (str === '0') return 0;
      return val;
    };

    const encodeCue = (val: any) => {
      if (val === null || val === undefined) return val;
      if (typeof val === 'number') return val;
      const str = String(val).toLowerCase();
      if (str === 'valid') return 0;
      if (str === 'invalid') return 1;
      if (str === 'neutral') return 2;
      return val;
    };

    const encodeAudioSource = (val: any) => {
      if (val === null || val === undefined) return val;
      if (typeof val === 'number') return val;
      const str = String(val).toLowerCase();
      if (str === 'speakers') return 0;
      if (str === 'headphones') return 1;
      return val;
    };

    const encodeModal = (val: any) => {
      if (val === null || val === undefined) return val;
      if (typeof val === 'number') return val;
      const str = String(val).toLowerCase();
      if (str === 'unimodal') return 1;
      if (str === 'bimodal') return 2;
      return val;
    };

    const encodeTarget = (val: any) => {
      if (val === null || val === undefined) return val;
      if (typeof val === 'number') return val;
      const str = String(val).toLowerCase();
      if (str === 'left') return 0;
      if (str === 'right') return 1;
      return val;
    };

    const encodeRecordType = (val: any) => {
      if (val === null || val === undefined) return val;
      if (typeof val === 'number') return val;
      const str = String(val).toLowerCase();
      if (str === 'correct') return 1;
      if (str === 'wrong_or_not_given') return 0;
      return val;
    };

    // Compute inter-trial time and kristina per user
    const interTrialByIndex: Record<number, number> = {};
    const kristinaByIndex: Record<number, number> = {};

    try {
      const sorted = [...data].sort((a, b) => {
        if (a.user_id === b.user_id) {
          const at = a.cueAppearanceTimeStamp ?? 0;
          const bt = b.cueAppearanceTimeStamp ?? 0;
          return at - bt;
        }
        return String(a.user_id).localeCompare(String(b.user_id));
      });

      let lastUser: any = null;
      let prevCueTs: number | null = null;
      let prevSOA: number | null = null;
      let prevRT: number | null = null;

      for (const item of sorted) {
        const user = item.user_id;
        const cueTs: number | null =
          item && typeof item.cueAppearanceTimeStamp === 'number'
            ? item.cueAppearanceTimeStamp
            : (item && item.cueAppearanceTimeStamp != null && !isNaN(Number(item.cueAppearanceTimeStamp))
                ? Number(item.cueAppearanceTimeStamp)
                : null);

        if (user !== lastUser) {
          if (typeof item.index === 'number') {
            interTrialByIndex[item.index] = 0;
            kristinaByIndex[item.index] = 0;
          }
          lastUser = user;
          prevCueTs = cueTs;
          prevSOA = Number(item?.soa);
          prevRT = Number(item?.response_time);
          continue;
        }

        if (typeof item.index === 'number') {
          if (prevCueTs != null && cueTs != null) {
            const inter = cueTs - prevCueTs;
            interTrialByIndex[item.index] = inter;
            const soaVal = prevSOA != null && !isNaN(prevSOA) ? prevSOA : 0;
            const rtVal = prevRT != null && !isNaN(prevRT) ? prevRT : 0;
            kristinaByIndex[item.index] = inter - soaVal - rtVal;
          } else {
            interTrialByIndex[item.index] = 0;
            kristinaByIndex[item.index] = 0;
          }
        }

        if (cueTs != null) prevCueTs = cueTs;
        prevSOA = Number(item?.soa);
        prevRT = Number(item?.response_time);
      }
    } catch (_) {
      for (const item of data || []) {
        if (typeof item?.index === 'number') {
          interTrialByIndex[item.index] = 0;
          kristinaByIndex[item.index] = 0;
        }
      }
    }

    // Process and format all records
    return data.map((item) => {
      // Determine response and correct_response (handle both field naming conventions)
      let response, correctResponse;
      
      if ('response' in item && item.response !== null && item.response !== undefined) {
        response = encodeUpDown(item.response);
      } else if ('given_answer' in item) {
        response = encodeUpDown(item.given_answer);
      }
      
      if ('correct_response' in item && item.correct_response !== null && item.correct_response !== undefined) {
        correctResponse = encodeUpDown(item.correct_response);
      } else if ('correct_answer' in item) {
        correctResponse = encodeUpDown(item.correct_answer);
      }

      // Format timestamps
      const cueAppearanceTimeStamp = item.cueAppearanceTimeStamp
        ? moment(item.cueAppearanceTimeStamp).format("YYYY-MM-DD HH:mm:ss.SSS")
        : null;
      const stimulusAppearanceTimeStamp = item.stimulusAppearanceTimeStamp
        ? moment(item.stimulusAppearanceTimeStamp).format("YYYY-MM-DD HH:mm:ss.SSS")
        : null;
      const buttonPressedTimeStamp = item.buttonPressedTimeStamp
        ? moment(item.buttonPressedTimeStamp).format("YYYY-MM-DD HH:mm:ss.SSS")
        : null;

      // Compute derived columns
      const interTrialTime =
        typeof item.index === 'number' && interTrialByIndex[item.index] != null
          ? interTrialByIndex[item.index]
          : 0;
      const kristina =
        typeof item.index === 'number' && kristinaByIndex[item.index] != null
          ? kristinaByIndex[item.index]
          : 0;

      // Return unified structure
      return {
        index: item.index,
        user_id: item.user_id,
        record_type: encodeRecordType(item.record_type),
        modal: encodeModal(item.modal),
        target: encodeTarget(item.target),
        response_time: item.response_time,
        response: response,
        soa: item.soa ?? null,
        correct_response: correctResponse,
        cue: encodeCue(item.cue),
        audio_source: encodeAudioSource(item.audio_source),
        cueAppearanceTimeStamp: cueAppearanceTimeStamp,
        stimulusAppearanceTimeStamp: stimulusAppearanceTimeStamp,
        buttonPressedTimeStamp: buttonPressedTimeStamp,
        lc_flag: item.lc_flag,
        interTrialTime: interTrialTime,
        kristina: kristina,
        round: item.round ?? null,
        trial_index: item.trial_index ?? null,
        block: item.block ?? null,
      };
    });
  }

  async downloadTaskDataAll(type) {
    let s_voucher = "";
    let s_valid = "";
    
    const loadingRef = this.dialog.open(LoadingDialog, { 
      disableClose: true,
      data: { message: 'Processing data...' }
    });
    
    try {
      const data = await this.adminService.getTaskDataByType(type, this.selectedAttempt);
      const userData = data.body;

        switch (type) {
          case "MovementPerception":
            const st3 = [];
            for (const us in userData) {
              let email = "";
              for (const x in this.allUsersIdEmail) {
                if (userData[us].user_id == this.allUsersIdEmail[x].id) {
                  email = this.allUsersIdEmail[x].email;
                }
              }
              const voucher = this.isUserNoVoucher(email);

              if (voucher == true) {
                s_voucher = "0";
              } else {
                s_voucher = "1";
              }
              const valid = this.isUserValid(email);
              if (valid == true) {
                s_valid = "1";
              } else {
                s_valid = "0";
              }
              let nat = this.userNation(email);
              if (nat == "") {
                nat = "EN";
              }

              const subId = this.userSubjectId(email);
              const subId_language_voucher =
                subId + "_" + nat + "_" + s_voucher;
              const language = this.language_mapping(nat);
              let voucher_language_subId = s_voucher + language + subId;
              if (subId == "-1") {
                voucher_language_subId = "-" + s_voucher + language + "1";
              }

              const ud = {
                // "index":userData[us].user_id,
                user_id: voucher_language_subId,
                voucher: s_voucher,
                valid: s_valid,
                language,
                lc_flag: userData[us].lc_flag,
                subId_language_voucher,
                adap_dir: userData[us].adap_dir,
                normal: userData[us].normal,
                response: userData[us].response,
                test_dir: userData[us].test_dir,
                time_ms: userData[us].time_ms,
                timecheck: userData[us].timecheck,
                trial_nr: userData[us].trial_nr,
              };
              st3.push(ud);
            }
            this.manageAndDownloadData(st3, type, " ");
            break;
          case "LoudnessPerception":
            const st5 = [];
            for (const us in userData) {
              let email = "";
              for (const x in this.allUsersIdEmail) {
                if (userData[us].user_id == this.allUsersIdEmail[x].id) {
                  email = this.allUsersIdEmail[x].email;
                }
              }
              const voucher = this.isUserNoVoucher(email);

              if (voucher == true) {
                s_voucher = "0";
              } else {
                s_voucher = "1";
              }
              const valid = this.isUserValid(email);
              if (valid == true) {
                s_valid = "1";
              } else {
                s_valid = "0";
              }
              let nat = this.userNation(email);
              if (nat == "") {
                nat = "EN";
              }
              const subId = this.userSubjectId(email);
              const subId_language_voucher =
                subId + "_" + nat + "_" + s_voucher;
              const language = this.language_mapping(nat);
              let voucher_language_subId = s_voucher + language + subId;
              if (subId == "-1") {
                voucher_language_subId = "-" + s_voucher + language + "1";
              }
              const ud = {
                // "index":userData[us].index,
                user_id: voucher_language_subId,
                voucher: s_voucher,
                valid: s_valid,
                language,
                lc_flag: userData[us].lc_flag,
                subId_language_voucher,
                rating_number: userData[us].rating_number,
                rate_loudness: userData[us].rate_loudness,
                audio_source: userData[us].audio_source,
              };
              st5.push(ud);
            }
            this.manageAndDownloadData(st5, type, " ");
            break;
          case "FlashBeep":
            const st6 = [];
            for (const us in userData) {
              let email = "";
              for (const x in this.allUsersIdEmail) {
                if (userData[us].user_id == this.allUsersIdEmail[x].id) {
                  email = this.allUsersIdEmail[x].email;
                }
              }
              const voucher = this.isUserNoVoucher(email);

              if (voucher == true) {
                s_voucher = "0";
              } else {
                s_voucher = "1";
              }
              const valid = this.isUserValid(email);
              if (valid == true) {
                s_valid = "1";
              } else {
                s_valid = "0";
              }
              let nat = this.userNation(email);
              if (nat == "") {
                nat = "EN";
              }

              const subId = this.userSubjectId(email);
              const subId_language_voucher =
                subId + "_" + nat + "_" + s_voucher;
              const language = this.language_mapping(nat);
              let voucher_language_subId = s_voucher + language + subId;
              if (subId == "-1") {
                voucher_language_subId = "-" + s_voucher + language + "1";
              }
              const ud = {
                user_id: voucher_language_subId,
                voucher: s_voucher,
                valid: s_valid,
                language,
                lc_flag: userData[us].lc_flag,
                subId_language_voucher,
                trial_number: userData[us].trial_number,
                intended_SOA: userData[us].intended_SOA,
                actual_SOA: userData[us].actual_SOA,
                flash_timeStamp: userData[us].flash_timeStamp,
                beep_timeStamp: userData[us].beep_timeStamp,
                response_timeStamp: userData[us].response_timeStamp,
                responded_flashFirst: userData[us].responded_flashFirst,
                audio_source: userData[us].audio_source,
                sub_response_time:
                  userData[us].flash_timeStamp > userData[us].beep_timeStamp
                    ? userData[us].response_timeStamp -
                      userData[us].flash_timeStamp
                    : userData[us].response_timeStamp -
                      userData[us].beep_timeStamp,
              };
              st6.push(ud);
            }
            const SOA_list = [
              -400, -240, -200, -160, -120, -80, -40, 0, 40, 80, 120, 160, 200,
              240, 400,
            ];
            const st7 = [];
            const array = [];

            for (const s in SOA_list) {
              const object_SOA = {
                soa: 0,
                trial: 0,
                sub_response_time: 0,
                correct_res: 0,
              };
              object_SOA.soa = SOA_list[s];
              array.push(object_SOA);
            }
            let cont = 0;
            for (const s in st6) {
              if (cont < 119) {
                for (const s1 in array) {
                  if (st6[s].intended_SOA == array[s1].soa) {
                    array[s1].trial++;
                    if (st6[s].flash_timeStamp > st6[s].beep_timeStamp) {
                      array[s1].sub_response_time +=
                        st6[s].response_timeStamp - st6[s].flash_timeStamp;
                    } else {
                      array[s1].sub_response_time +=
                        st6[s].response_timeStamp - st6[s].beep_timeStamp;
                    }
                    if (
                      (st6[s].intended_SOA >= 0 &&
                        st6[s].responded_flashFirst == 1) ||
                      (st6[s].intended_SOA < 0 &&
                        st6[s].responded_flashFirst == 0)
                    ) {
                      array[s1].correct_res++;
                    }
                  }
                }
                cont++;
              } else {
                for (const s1 in SOA_list) {
                  if (st6[s].intended_SOA == array[s1].soa) {
                    array[s1].soa = st6[s].intended_SOA;
                    array[s1].trial++;
                    if (st6[s].flash_timeStamp > st6[s].beep_timeStamp) {
                      array[s1].sub_response_time +=
                        st6[s].response_timeStamp - st6[s].flash_timeStamp;
                    } else {
                      array[s1].sub_response_time +=
                        st6[s].response_timeStamp - st6[s].beep_timeStamp;
                    }
                    if (
                      (st6[s].intended_SOA >= 0 &&
                        st6[s].responded_flashFirst == 1) ||
                      (st6[s].intended_SOA < 0 &&
                        st6[s].responded_flashFirst == 0)
                    ) {
                      array[s1].correct_res++;
                    }
                  }
                  const average_reaction_time =
                    array[s1].sub_response_time / array[s1].trial;
                  const accuracy = array[s1].correct_res / array[s1].trial;
                  const information = this.calculateInformation2(accuracy);
                  const information_rate = this.calculateInfRate2(
                    accuracy,
                    average_reaction_time
                  );
                  const ud1 = {
                    user_id: st6[s].user_id,
                    voucher: st6[s].voucher,
                    valid: st6[s].valid,
                    language: st6[s].language,
                    lc_flag: st6[s].lc_flag,
                    subId_language_voucher: st6[s].subId_language_voucher,
                    SOA: array[s1].soa,
                    n_trial: array[s1].trial,
                    average_reaction_time,
                    accuracy,
                    information,
                    information_rate,
                  };
                  cont = 0;
                  array[s1].trial = 0;
                  array[s1].correct_res = 0;
                  array[s1].sub_response_time = 0;
                  st7.push(ud1);
                }
              }
            }

            const st_6 = st6.map((item) => ({
              ...item,
              flash_timeStamp: moment(item.flash_timeStamp).format(
                "YYYY-MM-DD HH:mm:ss.SSS"
              ),
              beep_timeStamp: moment(item.beep_timeStamp).format(
                "YYYY-MM-DD HH:mm:ss.SSS"
              ),
              response_timeStamp: moment(item.response_timeStamp).format(
                "YYYY-MM-DD HH:mm:ss.SSS"
              ),
            }));
            this.downloadCsvZip3(
              st_6,
              st7,
              " ",
              "flash_beep",
              "flash_beep",
              "FB_statistics"
            );
            // this.mangageAndDownloadData(st6, type, " ");
            break;
          case "TargetDetection":
            // Backend now returns unified array with record_type field
            const formattedAllTargetDetectionData = this.formatTargetDetectionCombined(userData);
            this.manageAndDownloadData(formattedAllTargetDetectionData, type, " ");
            break;
          case "WordCategorization":
            const wordsMap = new Map(this.words.map(word => [word.id, word]));
            const emailMap = new Map(this.allUsersIdEmail.map(user => [user.id, user.email]));
            
            const userCache = new Map();
            
            const getUserInfo = (userId: string, email: string) => {
              if (!userCache.has(userId)) {
                const voucher = this.isUserNoVoucher(email);
                const valid = this.isUserValid(email);
                let nat = this.userNation(email);
                if (nat === "") {
                  nat = "EN";
                }
                const subId = this.userSubjectId(email);
                const language = this.language_mapping(nat);
                
                userCache.set(userId, {
                  voucher: voucher ? "0" : "1",
                  valid: valid ? "1" : "0",
                  nation: nat,
                  subId,
                  language: nat,
                  subId_language_voucher: `${subId}_${nat}_${voucher ? "0" : "1"}`,
                  voucher_language_subId: subId === "-1" 
                    ? `-${voucher ? "0" : "1"}${language}1`
                    : `${voucher ? "0" : "1"}${language}${subId}`
                });
              }
              return userCache.get(userId);
            };
            
            const userData0 = [];
            const userDataToShow0 = [];
            let control = 0;
            const v_voucher = {};
            const v_valid = {};
            const v_nation = {};
            const v_subIdLanVoucher = {};
            const v_VouLanSubId = {};
            const user_ids_traker = {};

            for (let i = 0; i < userData[0].length; i++) {
              const record = userData[0][i];
              const u_id = record.user_id;
              
              if (!(u_id in user_ids_traker)) {
                user_ids_traker[u_id] = 1;
              } else {
                user_ids_traker[u_id] = 0;
              }

              const word = wordsMap.get(record.word_id);
              if (word) {
                const email = emailMap.get(record.user_id) || "";
                
                const userInfo = getUserInfo(record.user_id, email);
                
                let is_user_response_correct = "";
                if (
                  (word.correct_response === "YES" && record.response_choice == 1) ||
                  (word.correct_response === "NO" && record.response_choice == 0)
                ) {
                  is_user_response_correct = "yes";
                } else {
                  is_user_response_correct = "no";
                }
                
                const dateString = record.timestamps;
                let differenceInMilliseconds = null;
                if (dateString && dateString.includes("_")) {
                  const [startDateString, endDateString] = dateString.split("_");
                  const startDate = new Date(startDateString);
                  const endDate = new Date(endDateString);
                  
                  // Check if dates are valid
                  if (!isNaN(startDate.getTime()) && !isNaN(endDate.getTime())) {
                    differenceInMilliseconds = endDate.getTime() - startDate.getTime();
                    if (user_ids_traker[u_id] == 1) {
                      differenceInMilliseconds -= 5 * 1000; // minus 5 seconds because there is the pause after the getReady
                    }
                    // Keep as number, don't convert to string here
                  }
                }

                v_voucher[record.user_id] = userInfo.voucher;
                v_valid[record.user_id] = userInfo.valid;
                v_nation[record.user_id] = userInfo.nation;
                v_subIdLanVoucher[record.user_id] = userInfo.subId_language_voucher;
                v_VouLanSubId[record.user_id] = userInfo.voucher_language_subId;

                let response_choice = 0;
                if (record.response_choice == true) {
                  response_choice = 1;
                }
                let correct_response = 0;
                let alive_notalive = NaN;
                let manmade_notmanmade = NaN;
                if (record.word_task == "alive_task") {
                  alive_notalive = 0;
                } else {
                  manmade_notmanmade = 0;
                }

                if (word.correct_response == "YES") {
                  correct_response = 1;
                  if (record.word_task == "alive_task") {
                    alive_notalive = 1;
                  } else {
                    manmade_notmanmade = 1;
                  }
                }

                let iurc = 0;
                if (is_user_response_correct == "yes") {
                  iurc = 1;
                }

                const temp = {
                  user_id: record.user_id,
                  voucher: userInfo.voucher,
                  valid: userInfo.valid,
                  language: userInfo.nation,
                  lc_flag: record.lc_flag,
                  subId_language_voucher: userInfo.subId_language_voucher,
                  response_choice: record.response_choice,
                  timestamps: record.timestamps,
                  word_id: record.word_id,
                  word: word.value,
                  correct_response: word.correct_response,
                  correct_response_item: word.correct_response_item,
                  correct_response_source: word.correct_response_source,
                  word_task: record.word_task,
                  response_time_ms: differenceInMilliseconds,
                  is_user_response_correct,
                };
                
                const temp1 = {
                  user_id: userInfo.voucher_language_subId,
                  voucher: userInfo.voucher,
                  valid: userInfo.valid,
                  language: userInfo.language,
                  lc_flag: record.lc_flag,
                  word: word.value,
                  user_given_response: response_choice,
                  expected_correct_response: correct_response,
                  is_user_response_correct: iurc,
                  alive_notAlive: alive_notalive,
                  manmade_notManmade: manmade_notmanmade,
                  response_time_ms: differenceInMilliseconds,
                };
                
                userData0.push(temp);
                control = 1;
                userDataToShow0.push(temp1);
              }
            }
            
            if (control == 0) {
              const temp = { nodata: "no data" };
              userData0.push(temp);
            }

            const word_frequency_map = new Map();
            
            for (const item of userData0) {
              const key = `${item.user_id}_${item.word}`;
              if (word_frequency_map.has(key)) {
                word_frequency_map.get(key).categorisation_occurrences++;
              } else {
                word_frequency_map.set(key, {
                  u_id: item.user_id,
                  word: item.word,
                  lc_flag: item.lc_flag,
                  categorisation_occurrences: 1,
                  recognition_occurrences: 0,
                });
              }
            }
            
            const userData1 = [];
            const userDataToShow1 = [];
            let control1 = 0;

            for (let i = 0; i < userData[1].length; i++) {
              const record = userData[1][i];
              
              const word = wordsMap.get(record.word_id);
              if (word) {
                const email = emailMap.get(record.user_id) || "";
                
                const userInfo = getUserInfo(record.user_id, email);
                
                v_voucher[record.user_id] = userInfo.voucher;
                v_valid[record.user_id] = userInfo.valid;
                v_nation[record.user_id] = userInfo.nation;
                v_subIdLanVoucher[record.user_id] = userInfo.subId_language_voucher;
                v_VouLanSubId[record.user_id] = userInfo.voucher_language_subId;

                let correct_response = 0;
                if (word.correct_response == "YES") {
                  correct_response = 1;
                }

                let correct_response_source = NaN;
                if (word.correct_response_source == "alive_task") {
                  correct_response_source = 1;
                }
                if (word.correct_response_source == "manmade_task") {
                  correct_response_source = 0;
                }

                let correct_response_item = 0;
                if (word.correct_response_item == "new") {
                  correct_response_item = 1;
                }
                if (word.correct_response_item == null) {
                  if (word.list == "alive_task") {
                    correct_response_source = 1;
                  }
                  if (word.list == "manmade_task") {
                    correct_response_source = 0;
                  }
                }

                const temp = {
                  user_id: record.user_id,
                  voucher: userInfo.voucher,
                  valid: userInfo.valid,
                  language: userInfo.nation,
                  lc_flag: record.lc_flag,
                  subId_language_voucher: userInfo.subId_language_voucher,
                  response_choice_old_new: record.response_choice_old_new,
                  response_choice_source: record.response_choice_source,
                  timestamp_old_new: record.timestamp_old_new,
                  timestamp_source: record.timestamp_source,
                  word_id: record.word_id,
                  word: word.value,
                  correct_response: word.correct_response,
                  correct_response_item: word.correct_response_item,
                  correct_response_source: word.correct_response_source,
                };
                
                const temp1 = {
                  user_id: userInfo.voucher_language_subId,
                  voucher: userInfo.voucher,
                  valid: userInfo.valid,
                  language: userInfo.language,
                  lc_flag: record.lc_flag,
                  word: word.value,
                  given_response_choice_old_new: record.response_choice_old_new,
                  given_response_choice_alive_manmade: record.response_choice_source,
                  wasOld_new: correct_response_item,
                  was_in_alive_manmade_list: correct_response_source,
                };
                
                userData1.push(temp);
                control1 = 1;
                userDataToShow1.push(temp1);
              }
            }
            
            if (control1 == 0) {
              const temp = { nodata: "no data" };
              userData1.push(temp);
            }

            if (control1 == 0) {
              const temp = { nodata: "no data" };
              userData1.push(temp);
            }
            
            for (const item of userData1) {
              const key = `${item.user_id}_${item.word}`;
              if (word_frequency_map.has(key)) {
                word_frequency_map.get(key).recognition_occurrences++;
              } else {
                word_frequency_map.set(key, {
                  u_id: item.user_id,
                  word: item.word,
                  lc_flag: item.lc_flag,
                  categorisation_occurrences: 0,
                  recognition_occurrences: 1,
                });
              }
            }
            
            const word_frequency = Array.from(word_frequency_map.values());

            const stats = {};

            let control2 = 0;
            for (const item in userData0) {
              if (userData0[item].timestamps.includes("_")) {
                control2 = 1;
                const userId = userData0[item].user_id;
                const correctResponse =
                  userData0[item].is_user_response_correct === "yes";

                if (!stats[userId]) {
                  stats[userId] = {
                    reactionTimes: [],
                    totalResponses: 0,
                    correctResponses: 0,
                  };
                }

                stats[userId].totalResponses++;
                if (correctResponse) {
                  stats[userId].correctResponses++;
                  const responseTime = this.safeParseResponseTime(userData0[item].response_time_ms);
                  if (responseTime !== null) {
                    stats[userId].reactionTimes.push(responseTime);
                  }
                }
              } else {
                const userId = userData0[item].user_id;
                const correctResponse =
                  userData0[item].is_user_response_correct === "yes";

                if (!stats[userId]) {
                  stats[userId] = {
                    reactionTimes: [],
                    totalResponses: 0,
                    correctResponses: 0,
                  };
                }

                stats[userId].reactionTimes.push(" ");
                stats[userId].totalResponses++;
                if (correctResponse) {
                  stats[userId].correctResponses++;
                }
              }
            }

            const mean_stdDev = [];

            for (const userId in stats) {
              const totalResponses = stats[userId].totalResponses;
              const correctResponses = stats[userId].correctResponses;
              const accuracyPercentage =
                (correctResponses / totalResponses) * 100;
              const lcFlag = stats[userId].lc_flag;

              if (control2 == 1) {
                const reactionTimes = stats[userId].reactionTimes;
                const mean = this.calculateMean(reactionTimes);
                const stdDev = this.calculateStandardDeviation(reactionTimes);

                mean_stdDev.push({
                  user_id: userId,
                  voucher: v_voucher[userId],
                  valid: v_valid[userId],
                  language: v_nation[userId],
                  lc_flag: lcFlag,
                  subId_language_voucher: v_subIdLanVoucher[userId],
                  mean,
                  standard_deviation: stdDev,
                  correct_answers_percentage: accuracyPercentage,
                });
              } else {
                mean_stdDev.push({
                  user_id: userId,
                  voucher: v_voucher[userId],
                  valid: v_valid[userId],
                  language: v_nation[userId],
                  lc_flag: lcFlag,
                  subId_language_voucher: v_subIdLanVoucher[userId],
                  mean: "",
                  standard_deviation: "",
                  correct_answers_percentage: accuracyPercentage,
                });
              }
            }

            const user_ic = {};
            const user_ec = {};
            const user_iw = {};
            const user_ew = {};
            const user_ng = {};
            const user_tot_answ = {};

            for (const i in word_frequency) {
              user_ic[word_frequency[i].u_id] = 0;
              user_ec[word_frequency[i].u_id] = 0;
              user_iw[word_frequency[i].u_id] = 0;
              user_ew[word_frequency[i].u_id] = 0;
              user_ng[word_frequency[i].u_id] = 0;
              user_tot_answ[word_frequency[i].u_id] = 0;
            }

            const userData1Map = new Map();
            for (const item of userData1) {
              const key = `${item.user_id}_${item.word}`;
              userData1Map.set(key, item);
            }
            
            for (const wf of word_frequency) {
              const key = `${wf.u_id}_${wf.word}`;
              const userData1Item = userData1Map.get(key);
              
              if (userData1Item) {
                user_tot_answ[wf.u_id] += 1;
                if (wf.categorisation_occurrences != wf.recognition_occurrences) {
                  if (userData1Item.response_choice_old_new == 2) {
                    user_ic[wf.u_id] += 1;
                  }
                  if (userData1Item.response_choice_old_new == 1) {
                    user_ec[wf.u_id] += 1;
                  }
                  if (userData1Item.response_choice_old_new == 4) {
                    user_iw[wf.u_id] += 1;
                  }
                  if (userData1Item.response_choice_old_new == 5) {
                    user_ew[wf.u_id] += 1;
                  }
                  if (userData1Item.response_choice_old_new == 3) {
                    user_ng[wf.u_id] += 1;
                  }
                }
                if (wf.categorisation_occurrences == wf.recognition_occurrences) {
                  if (userData1Item.response_choice_old_new == 4) {
                    user_ic[wf.u_id] += 1;
                  }
                  if (userData1Item.response_choice_old_new == 5) {
                    user_ec[wf.u_id] += 1;
                  }
                  if (userData1Item.response_choice_old_new == 2) {
                    user_iw[wf.u_id] += 1;
                  }
                  if (userData1Item.response_choice_old_new == 1) {
                    user_ew[wf.u_id] += 1;
                  }
                  if (userData1Item.response_choice_old_new == 3) {
                    user_ng[wf.u_id] += 1;
                  }
                }
              }
            }

            for (const g in user_ic) {
              user_ic[g] = (user_ic[g] / user_tot_answ[g]) * 100;
              user_ec[g] = (user_ec[g] / user_tot_answ[g]) * 100;
              user_iw[g] = (user_iw[g] / user_tot_answ[g]) * 100;
              user_ew[g] = (user_ew[g] / user_tot_answ[g]) * 100;
              user_ng[g] = (user_ng[g] / user_tot_answ[g]) * 100;
            }

            const st = [];

            for (const k in mean_stdDev) {
              const t = {
                user_id: mean_stdDev[k].user_id,
                voucher: v_voucher[mean_stdDev[k].user_id],
                valid: v_valid[mean_stdDev[k].user_id],
                language: v_nation[mean_stdDev[k].user_id],
                lc_flag: mean_stdDev[k].lc_flag,
                subId_language_voucher:
                  v_subIdLanVoucher[mean_stdDev[k].user_id],
                mean: mean_stdDev[k].mean,
                standard_deviation: mean_stdDev[k].standard_deviation,
                correct_answers_percentage:
                  mean_stdDev[k].correct_answers_percentage,
                IC: user_ic[mean_stdDev[k].user_id],
                EC: user_ec[mean_stdDev[k].user_id],
                IW: user_iw[mean_stdDev[k].user_id],
                EW: user_ew[mean_stdDev[k].user_id],
                NG: user_ng[mean_stdDev[k].user_id],
              };
              st.push(t);
            }

            const react_t_map = new Map();
            for (const item of userData0) {
              const userId = item.user_id;
              const responseTime = this.safeParseResponseTime(item.response_time_ms);
              
              if (responseTime !== null) {
                if (react_t_map.has(userId)) {
                  const existing = react_t_map.get(userId);
                  existing.reaction_time_sum += responseTime;
                  existing.n_reaction_times += 1;
                } else {
                  react_t_map.set(userId, {
                    user_id: userId,
                    lc_flag: item.lc_flag,
                    reaction_time_sum: responseTime,
                    n_reaction_times: 1,
                  });
                }
              }
            }
            const react_t = Array.from(react_t_map.values());
            const react_t_by_user = new Map();
            for (const item of react_t) {
              react_t_by_user.set(item.user_id, item);
            }
            
            const st1 = [];
            for (const item of st) {
              const react_item = react_t_by_user.get(item.user_id);
              if (react_item) {
                const infRate = this.calculateInfRate(
                  item.correct_answers_percentage,
                  react_item.reaction_time_sum / react_item.n_reaction_times
                );
                const information = this.calculateInformation(
                  item.correct_answers_percentage
                );
                let mean = item.mean;
                if (item.mean == 0) {
                  mean = NaN;
                }
                let std = item.standard_deviation;
                if (item.standard_deviation == 0) {
                  std = NaN;
                }
                const MT_C = item.IC + item.EC;
                const t = {
                  user_id: v_VouLanSubId[item.user_id],
                  voucher: v_voucher[item.user_id],
                  valid: v_valid[item.user_id],
                  language: this.language_mapping(v_nation[item.user_id]),
                  lc_flag: item.lc_flag,
                  WC_CorrAns_RT_mean: mean,
                  WC_CorrAns_RT_SD: std,
                  WC_correct_answers_percentage: item.correct_answers_percentage,
                  WC_information: information,
                  WC_information_rate: infRate * 1000,
                  MT_IC: item.IC,
                  MT_EC: item.EC,
                  MT_IW: item.IW,
                  MT_EW: item.EW,
                  MT_NG: item.NG,
                  MT_C,
                };
                st1.push(t);
              }
            }
            const word_frequency_to_show = [];
            for (const w in word_frequency) {
              word_frequency_to_show.push({
                uid: v_VouLanSubId[word_frequency[w].u_id],
                voucher: v_voucher[word_frequency[w].u_id],
                valid: v_valid[word_frequency[w].u_id],
                language: v_nation[word_frequency[w].u_id],
                lc_flag: word_frequency[w].lc_flag,
                word: word_frequency[w].word,
                categorisation_occurrences:
                  word_frequency[w].categorisation_occurrences,
                recognition_occurrences:
                  word_frequency[w].recognition_occurrences,
              });
            }
            this.downloadCsvZip2(
              userDataToShow0,
              userDataToShow1,
              word_frequency_to_show,
              st1,
              " ",
              "word_categorization",
              "word_categorization",
              "word_recognition",
              "word_frequency_tot_categorization_task",
              "WC_MT_statistics"
            );
            break;
          default:
            this.manageAndDownloadData(userData, type, " ");
        }
    } catch (error) {
      alert('Error processing data. Please try again.');
    } finally {
      loadingRef.close();
    }
  }

  extractHeader(userData) {
    return Object.keys(userData[0]);
  }

  createRows(userData, header) {
    return userData.map((obj) =>
      header.map((key) => {
        let value = obj[key];
        if (
          typeof value === "string" &&
          (value.includes(",") || value.includes("\n"))
        ) {
          value = `"${value}"`; // enclose the field in quotes
        }
        return value;
      })
    );
  }

  createCsvData(header, rows) {
    return [header, ...rows].map((row) => row.join(",")).join("\n");
  }

  createCsvBlob(csvData) {
    return new Blob([csvData], { type: "text/csv" });
  }

  createCsvDownloadLink(blob, userEmail, type) {
    const emailShort = userEmail
      .substring(0, userEmail.indexOf("@"))
      .replace(/\./g, "");
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    if (emailShort != "") {
      link.download = emailShort + "_" + type.toLowerCase() + ".csv";
    } else {
      link.download = emailShort + type.toLowerCase() + ".csv";
    }
    link.click();
    window.URL.revokeObjectURL(url);
  }

  manageAndDownloadData(userData, type, userEmail) {
    const header = this.extractHeader(userData);
    let rows = this.createRows(userData, header);
    // If filter is needed to download data
    if (userEmail === " " && this.selectedFilterByTask != "AllUsers") {
      // List of user_id from the active filter
      const emailSet = new Set(
        this.activeUsersShown.map((item) => item.user_id)
      );
      let filteredData;
      switch (this.selectedTask) {
        // <== Questionaires ==>
        case "Covid":
        case "Demographic":
        case "Fatigue":
        case "Personality":
        case "Quality":
        case "SeverityIndexes":
          filteredData = userData.filter((item) => emailSet.has(item.uid));
          rows = this.createRows(filteredData, header);
          break;
        // <== Tasks ==>
        case "FlashBeep":
        case "LoudnessPerception":
        case "MovementPerception":
          // "TargetDetection" and "WordCategorization" is downloadCsvZip functions
          filteredData = this.filter_downloadCsvZip2(userData, userEmail);
          rows = this.createRows(filteredData, header);
          break;
        // <== Users Information ==>
        case "UsersInfo":
          filteredData = userData.filter((item) => emailSet.has(item.user_id));
          rows = this.createRows(filteredData, header);
          break;
        // <== Charlie ==>
        case "Charlie":
          filteredData = userData.filter((item) => emailSet.has(item.user_id));
          rows = this.createRows(filteredData, header);
          break;
        case "FactorAnalysis":
          filteredData = userData.filter((item) => emailSet.has(item.user_id));
          rows = this.createRows(filteredData, header);
          break;
      }
    }
    const riga = [];
    if (this.selectedTask === "Charlie") {
      const emailIndexMap = new Map(); // Utilizzato per tenere traccia delle email e dei loro indici in rows
      let ch = "0";
      for (let i = 0; i < rows.length; i++) {
        if (rows[i][1].split("_")[1] > ch) {
          ch = rows[i][1].split("_")[1];
        }
        const currentEmail = rows[i][0];
        if (!emailIndexMap.has(currentEmail)) {
          emailIndexMap.set(currentEmail, []);
        }
        emailIndexMap.get(currentEmail).push(i);
      }

      for (const h in header) {
        if (
          header[h] !== "email" &&
          header[h] !== "user_id" &&
          header[h] != "uid" &&
          header[h] != "voucher" &&
          header[h] != "valid" &&
          header[h] != "language" &&
          header[h] != "country" &&
          header[h] != "gender" &&
          header[h] != "age" &&
          header[h] != "education"
        ) {
          header[h] = header[h] + "_1";
        }
      }

      for (const [email, indices] of emailIndexMap) {
        if (indices.length > 1) {
          for (let i = 0; i < indices.length; i++) {
            for (let j = i + 1; j < indices.length; j++) {
              const rowData = rows[indices[i]].slice();
              rowData[1] = rowData[1].split("_")[0];
              const concatrow = rows[indices[j]].splice(10);
              const duplicateRow = rowData.concat(concatrow);
              riga.push(duplicateRow);
            }
          }
        }
      }

      const newHead = [];
      let header_2 = [];
      const first_elem = header.slice(0, 10);

      const ch_num = parseInt(ch);
      for (let n = 1; n <= ch_num; n++) {
        for (const h in header) {
          if (
            header[h] !== "email" &&
            header[h] !== "user_id" &&
            header[h] != "uid" &&
            header[h] != "voucher" &&
            header[h] != "valid" &&
            header[h] != "language" &&
            header[h] != "country" &&
            header[h] != "gender" &&
            header[h] != "age" &&
            header[h] != "education"
          ) {
            let num_und = 0;
            const split = header[h].split("_");
            for (let i = 0; i < header[h].length; i++) {
              if (header[h][i] == "_") {
                num_und++;
              }
            }
            split[num_und] = "" + n;
            header[h] = split.join("_");
            newHead.push(header[h]);
          }
        }
      }
      header_2 = first_elem.concat(newHead);
      const riga2 = [...riga];

      for (const e in rows) {
        let contr = 0;
        for (const x in riga) {
          if (rows[e][0] == riga[x][0]) {
            contr = 1;
          }
        }
        if (contr == 0) {
          const len = header_2.length - rows[e].length + 10;
          const newArrayEmpty = new Array(len).fill("NULL");
          const concatrow = newArrayEmpty.splice(10);
          rows[e][1] = rows[e][1].split("_")[0];
          riga2.push(rows[e].concat(concatrow));
        }
      }
      const csvData = this.createCsvData(header_2, riga2);
      const blob = this.createCsvBlob(csvData);
      this.createCsvDownloadLink(blob, userEmail, type);
    } else if (this.selectedTask === "Covid") {
      const covidHeader = [
        "uid",
        "voucher",
        "valid",
        "language",
        "lc_flag",
        "subId_language_voucher",
        "type",
        "q1",
        "q2",
        "q3",
        "q4",
        "q5",
        "q6",
        "q7",
        "q8",
        "q9",
        "q10",
        "q11",
        "q12",
        "q13",
        "q14",
        "q15",
        "q16",
      ];
      const covidHeaderEncoded = this.extractHeader([
        userData[0].encoded_covid_answers,
      ]);
      const fullCovidHeaderEncoded = [
        ...covidHeader.slice(0, 7),
        ...covidHeaderEncoded,
      ];

      const covidRows = this.transformData(rows);
      const csvData = this.createCsvData(covidHeader, covidRows);
      const blob = this.createCsvBlob(csvData);
      this.createCsvDownloadLink(blob, userEmail, type);

      const rowsEncoded = this.transformData(rows, true, 16, "Covid");
      const csvDataEncoded = this.createCsvData(
        fullCovidHeaderEncoded,
        rowsEncoded
      );
      const blobEncoded = this.createCsvBlob(csvDataEncoded);
      this.createCsvDownloadLink(blobEncoded, userEmail, type + "_encoded");
    } else if (this.selectedTask === "Fatigue") {
      const fatigueHeader = [
        "uid",
        "voucher",
        "valid",
        "language",
        "lc_flag",
        "subId_language_voucher",
        "type",
        "q1",
        "q2",
        "q3",
        "q4",
        "q5",
        "q6",
        "q7",
        "q8",
        "q9",
        "q10",
        "q11",
      ];

      const fatigueRows = this.transformData(rows, false, 11);
      const csvData = this.createCsvData(fatigueHeader, fatigueRows);
      const blob = this.createCsvBlob(csvData);
      this.createCsvDownloadLink(blob, userEmail, type);

      const rowsEncoded = this.transformData(rows, true, 11);
      const csvDataEncoded = this.createCsvData(fatigueHeader, rowsEncoded);
      const blobEncoded = this.createCsvBlob(csvDataEncoded);
      this.createCsvDownloadLink(blobEncoded, userEmail, type + "_encoded");
    } else if (this.selectedTask === "Quality") {
      const qualityHeader = [
        "uid",
        "voucher",
        "valid",
        "language",
        "lc_flag",
        "subId_language_voucher",
        "type",
        "q1",
        "q2",
        "q3",
        "q4",
        "q5",
        "q6",
        "q7",
        "q8",
        "q9",
        "q10",
        "q11",
        "q12",
        "q13",
        "q14",
        "q15",
        "q16",
      ];

      const qualityRows = this.transformData(rows, false, 16);
      const csvData = this.createCsvData(qualityHeader, qualityRows);
      const blob = this.createCsvBlob(csvData);
      this.createCsvDownloadLink(blob, userEmail, type);

      const rowsEncoded = this.transformData(rows, true, 16);
      const csvDataEncoded = this.createCsvData(qualityHeader, rowsEncoded);
      const blobEncoded = this.createCsvBlob(csvDataEncoded);
      this.createCsvDownloadLink(blobEncoded, userEmail, type + "_encoded");
    } else if (this.selectedTask === "SeverityIndexes") {
      const indexHeader = [
        "uid",
        "LCSI1",
        "LCSI2",
        "lc_flag",
        "factor1_influenza_symptoms",
        "factor2_gastrointestinal_symptoms",
        "factor3_fatigue_symptoms",
        "factor4_mixed_symptoms",
        "factor5_psychological_symptoms",
      ];

      const result = {};
      rows.forEach((row) => {
        const uid = row[0];
        const LCSI1 = row[12];
        const LCSI2 = row[13];
        const lc_flag = row[11];
        const factor1_influenza_symptoms = row[14];
        const factor2_gastrointestinal_symptoms = row[15];
        const factor3_fatigue_symptoms = row[16];
        const factor4_mixed_symptoms = row[17];
        const factor5_psychological_symptoms = row[18];

        if (!result[uid]) {
          result[uid] = [
            uid,
            LCSI1,
            LCSI2,
            lc_flag,
            factor1_influenza_symptoms,
            factor2_gastrointestinal_symptoms,
            factor3_fatigue_symptoms,
            factor4_mixed_symptoms,
            factor5_psychological_symptoms,
          ];
        }
      });
      rows = Object.values(result);

      const csvData = this.createCsvData(indexHeader, rows);
      const blob = this.createCsvBlob(csvData);
      this.createCsvDownloadLink(blob, userEmail, type);
    } else if (this.selectedTask === "Demographic") {
      const demographicHeader = [
        "uid",
        "voucher",
        "valid",
        "language",
        "lc_flag",
        "subId_language_voucher",
        "type",
        "q1",
        "q2",
        "q3",
        "q4",
        "q5",
        "q6",
        "q7",
        "q8",
        "q9",
        "q10",
        "q11",
        "q12",
      ];

      const demographicRows = this.transformData(
        rows,
        false,
        16,
        "Demographic"
      );
      const csvData = this.createCsvData(demographicHeader, demographicRows);
      const blob = this.createCsvBlob(csvData);
      this.createCsvDownloadLink(blob, userEmail, type);

      const demographicHeaderEncoded = [
        "uid",
        "voucher",
        "valid",
        "language",
        "lc_flag",
        "subId_language_voucher",
        "type",
        "q1",
        "q2",
        "q3",
        "q4",
        "q5",
        "q6",
        "q7",
        "q8",
        "q9_lung_conditions",
        "q9_heart_disease",
        "q9_chronic_kidney_disease",
        "q9_liver_disease",
        "q9_diabetes",
        "q9_high_blood_pressure",
        "q9_irregular_heartbeat",
        "q9_problems_with_your_spleen",
        "q9_none_of_the_above",
        "q10",
        "q11",
        "q12",
      ];

      const rowsEncoded = this.transformData(rows, true, 16, "Demographic");
      const csvDataEncoded = this.createCsvData(
        demographicHeaderEncoded,
        rowsEncoded
      );
      const blobEncoded = this.createCsvBlob(csvDataEncoded);
      this.createCsvDownloadLink(blobEncoded, userEmail, type + "_encoded");
    } else if (this.selectedTask === "Personality") {
      const demographicHeader = [
        "uid",
        "voucher",
        "valid",
        "language",
        "lc_flag",
        "subId_language_voucher",
        "type",
        "q1",
        "q2",
        "q3",
        "q4",
        "q5",
        "q6",
        "q7",
        "q8",
        "q9",
        "q10",
        "q11",
        "q12",
        "q13",
        "q14",
        "q15",
        "q16",
        "q17",
        "q18",
        "q19",
        "q20",
        "q21",
        "q22",
        "q23",
        "q24",
        "q25",
        "q26",
        "q27",
        "q28",
        "q29",
        "q30",
        "q31",
        "q32",
        "q33",
      ];

      const demographicRows = this.transformData(
        rows,
        false,
        33,
        "Personality"
      );
      const csvData = this.createCsvData(demographicHeader, demographicRows);
      const blob = this.createCsvBlob(csvData);
      this.createCsvDownloadLink(blob, userEmail, type);

      const rowsEncoded = this.transformData(rows, true, 33, "Personality");
      const csvDataEncoded = this.createCsvData(demographicHeader, rowsEncoded);
      const blobEncoded = this.createCsvBlob(csvDataEncoded);
      this.createCsvDownloadLink(blobEncoded, userEmail, type + "_encoded");
    } else {
      const csvData = this.createCsvData(header, rows);
      const blob = this.createCsvBlob(csvData);
      this.createCsvDownloadLink(blob, userEmail, type);
    }
  }

  splitOptions(str: string): string[] {
    const result = [];
    let current = "";
    let depth = 0;
    for (let i = 0; i < str.length; i++) {
      const char = str[i];
      if (char === "(") depth++;
      if (char === ")") depth--;
      if (char === "," && depth === 0) {
        result.push(current.trim());
        current = "";
      } else {
        current += char;
      }
    }
    if (current.trim() !== "") result.push(current.trim());
    return result;
  }

  transformData(
    data,
    encoded = false,
    numberOfQuestions = 16,
    questionType = "General"
  ) {
    let result = {};

    const DEMOGRAPHIC_Q9_OPTIONS = [
      "Lung conditions (e.g. asthma, emphysema or bronchitis)",
      "Heart disease",
      "Chronic kidney disease",
      "Liver disease (e.g. hepatitis)",
      "Diabetes",
      "High blood pressure",
      "Irregular heartbeat (atrial fibrillation)",
      "Problems with your spleen (e.g. sickle cell disease, or if you have had your spleen removed)",
      "None of the above",
    ];

    data.forEach((row) => {
      const uid = row[0];
      const voucher = row[1];
      const valid = row[2];
      const language = row[3];
      const lc_flag =
        questionType === "Demographic" || questionType === "Personality"
          ? row[10]
          : row[11];
      const subId_language_voucher = row[4];
      const answer = row[5];
      const answer_enum_id =
        questionType === "Demographic" || questionType === "Personality"
          ? row[9]
          : row[6];
      let question_no =
        questionType === "Demographic" || questionType === "Personality"
          ? row[7]
          : row[9];
      const type =
        questionType === "Demographic" || questionType === "Personality"
          ? row[8]
          : row[10];

      if (questionType === "Covid" && encoded) {
        const answersObj = row[19] || {};
        const answers = Object.values(answersObj);
        result[uid] = [
          uid,
          voucher,
          valid,
          language,
          lc_flag,
          subId_language_voucher,
          type,
          ...answers,
        ];
      } else if (questionType === "Demographic" && encoded) {
        const Q1_OFFSET = 7;
        const Q9_OFFSET = Q1_OFFSET + 8;
        const Q10_OFFSET = Q9_OFFSET + DEMOGRAPHIC_Q9_OPTIONS.length;

        if (!result[uid]) {
          result[uid] = [
            uid,
            voucher,
            valid,
            language,
            lc_flag,
            subId_language_voucher,
            type,
            ...Array(8).fill(null),
            ...Array(DEMOGRAPHIC_Q9_OPTIONS.length).fill(0),
            ...Array(4).fill(null),
          ];
        }

        if (question_no >= 1 && question_no <= 8) {
          result[uid][Q1_OFFSET + (question_no - 1)] =
            answer_enum_id == null ? answer : answer_enum_id;
        } else if (question_no === 9) {
          const selectedOptions = this.splitOptions(answer || "");
          DEMOGRAPHIC_Q9_OPTIONS.forEach((option, idx) => {
            result[uid][Q9_OFFSET + idx] = selectedOptions.includes(option)
              ? 1
              : 0;
          });
        } else if (question_no > 9 && question_no <= numberOfQuestions) {
          result[uid][Q10_OFFSET + (question_no - 10)] =
            answer_enum_id == null ? answer : answer_enum_id;
        }
      } else if (questionType === "Personality") {
        if (!result[uid]) {
          result[uid] = [
            uid,
            voucher,
            valid,
            language,
            lc_flag,
            subId_language_voucher,
            type,
            ...Array(numberOfQuestions).fill(null),
          ];
        }
        question_no -= 16;
        if (question_no >= 1 && question_no <= numberOfQuestions) {
          result[uid][question_no + 6] = encoded
            ? answer_enum_id == null
              ? answer
              : answer_enum_id
            : answer;
        }
      } else {
        if (!result[uid]) {
          result[uid] = [
            uid,
            voucher,
            valid,
            language,
            lc_flag,
            subId_language_voucher,
            type,
            ...Array(numberOfQuestions).fill(null),
          ];
        }
        if (question_no >= 1 && question_no <= numberOfQuestions) {
          result[uid][question_no + 6] = encoded
            ? answer_enum_id == null
              ? answer
              : answer_enum_id
            : answer;
        }
      }
    });

    return Object.values(result);
  }

  downloadCsvZip(
    records_1,
    records_2,
    userEmail,
    zipName,
    firstCsvName,
    secondCsvName
  ) {
    // Extract header and create rows for CSV files
    const header_1 = this.extractHeader(records_1);
    let rows_1 = this.createRows(records_1, header_1);
    // If filter is needed to download data
    if (userEmail === " " && this.selectedFilterByTask != "AllUsers") {
      const emailSet = new Set(
        this.activeUsersShown.map((item) => item.user_id)
      );
      const filteredData = records_1.filter((item) =>
        emailSet.has(item.user_id)
      );
      rows_1 = this.createRows(filteredData, header_1);
    }
    const csvData_1 = this.createCsvData(header_1, rows_1);

    const header_2 = this.extractHeader(records_2);
    let rows_2 = this.createRows(records_2, header_2);
    // If filter is needed to download data
    if (userEmail === " " && this.selectedFilterByTask != "AllUsers") {
      const emailSet = new Set(
        this.activeUsersShown.map((item) => item.user_id)
      );
      const filteredData = records_2.filter((item) =>
        emailSet.has(item.user_id)
      );
      rows_2 = this.createRows(filteredData, header_2);
    }
    const csvData_2 = this.createCsvData(header_2, rows_2);

    // Create Blob objects from CSV data
    const blob_1 = this.createCsvBlob(csvData_1);
    const blob_2 = this.createCsvBlob(csvData_2);

    // Create download links and trigger downloads

    const emailShort = userEmail
      .substring(0, userEmail.indexOf("@"))
      .replace(/\./g, "");
    if (emailShort != "") {
      const zip = new JSZip();

      zip.file(`${emailShort}_${firstCsvName}.csv`, blob_1);
      zip.file(`${emailShort}_${secondCsvName}.csv`, blob_2);
      zip.generateAsync({ type: "blob" }).then(function (content) {
        saveAs(content, `${emailShort}_${zipName}.zip`);
      });
    } else {
      const zip = new JSZip();

      zip.file(`${firstCsvName}.csv`, blob_1);
      zip.file(`${secondCsvName}.csv`, blob_2);
      zip.generateAsync({ type: "blob" }).then(function (content) {
        saveAs(content, `${zipName}.zip`);
      });
    }
  }

  downloadCsvZip1(
    records_1,
    records_2,
    records_3,
    userEmail,
    zipName,
    firstCsvName,
    secondCsvName,
    thirdCsvName
  ) {
    // Extract header and create rows for CSV files
    const header_1 = this.extractHeader(records_1);
    const rows_1 = this.createRows(records_1, header_1);
    const csvData_1 = this.createCsvData(header_1, rows_1);

    const header_2 = this.extractHeader(records_2);
    const rows_2 = this.createRows(records_2, header_2);
    const csvData_2 = this.createCsvData(header_2, rows_2);

    const header_3 = this.extractHeader(records_3);
    const rows_3 = this.createRows(records_3, header_3);
    const csvData_3 = this.createCsvData(header_3, rows_3);

    // Create Blob objects from CSV data
    const blob_1 = this.createCsvBlob(csvData_1);
    const blob_2 = this.createCsvBlob(csvData_2);
    const blob_3 = this.createCsvBlob(csvData_3);

    // Create download links and trigger downloads

    const emailShort = userEmail
      .substring(0, userEmail.indexOf("@"))
      .replace(/\./g, "");
    if (emailShort != "") {
      const zip = new JSZip();

      zip.file(`${emailShort}_${firstCsvName}.csv`, blob_1);
      zip.file(`${emailShort}_${secondCsvName}.csv`, blob_2);
      zip.file(`${emailShort}_${thirdCsvName}.csv`, blob_3);
      zip.generateAsync({ type: "blob" }).then(function (content) {
        saveAs(content, `${emailShort}_${zipName}.zip`);
      });
    } else {
      const zip = new JSZip();

      zip.file(`${firstCsvName}.csv`, blob_1);
      zip.file(`${secondCsvName}.csv`, blob_2);
      zip.file(`${thirdCsvName}.csv`, blob_3);
      zip.generateAsync({ type: "blob" }).then(function (content) {
        saveAs(content, `${zipName}.zip`);
      });
    }
  }

  filter_downloadCsvZip2(records, userEmail) {
    if (userEmail === " " && this.selectedFilterByTask != "AllUsers") {
      switch (this.selectedFilterByTask) {
        case "Voucher":
          records = records.filter((entry) => entry.voucher === "1");
          break;
        case "NoVoucher":
          records = records.filter((entry) => entry.voucher === "0");
          break;
        case "Italian":
          records = records.filter((entry) => entry.language === "1");
          break;
        case "Spanish":
          records = records.filter((entry) => entry.language === "2");
          break;
      }
    }
    return records;
  }

  downloadCsvZip2(
    records_1,
    records_2,
    records_3,
    records_4,
    userEmail,
    zipName,
    firstCsvName,
    secondCsvName,
    thirdCsvName,
    fourCsvName
  ) {
    // Extract header and create rows for CSV files
    const header_1 = this.extractHeader(records_1);
    records_1 = this.filter_downloadCsvZip2(records_1, userEmail);
    const rows_1 = this.createRows(records_1, header_1);
    const csvData_1 = this.createCsvData(header_1, rows_1);

    const header_2 = this.extractHeader(records_2);
    records_2 = this.filter_downloadCsvZip2(records_2, userEmail);
    const rows_2 = this.createRows(records_2, header_2);
    const csvData_2 = this.createCsvData(header_2, rows_2);

    const header_3 = this.extractHeader(records_3);
    records_3 = this.filter_downloadCsvZip2(records_3, userEmail);
    const rows_3 = this.createRows(records_3, header_3);
    const csvData_3 = this.createCsvData(header_3, rows_3);

    const header_4 = this.extractHeader(records_4);
    records_4 = this.filter_downloadCsvZip2(records_4, userEmail);
    const rows_4 = this.createRows(records_4, header_4);
    let ch = 0;
    for (let i = 0; i < records_4.length; i++) {
      let occ = 0;
      for (let j = 0; j < records_4.length; j++) {
        if (records_4[i].user_id == records_4[j].user_id) {
          occ++;
        }
      }
      if (occ > ch) {
        ch = occ;
      }
    }
    const groupedData = new Map();

    for (let i = 0; i < rows_4.length; i++) {
      const userId = rows_4[i][0];
      if (!groupedData.has(userId)) {
        groupedData.set(userId, []);
      }
      groupedData.get(userId).push(i);
    }

    for (const h in header_4) {
      if (
        header_4[h] !== "user_id" &&
        header_4[h] !== "voucher" &&
        header_4[h] != "valid" &&
        header_4[h] != "language"
      ) {
        header_4[h] = header_4[h] + "_1";
      }
    }

    const mergedData = [];
    for (const [userId, indices] of groupedData) {
      if (indices.length > 1) {
        for (let i = 0; i < indices.length; i++) {
          for (let j = i + 1; j < indices.length; j++) {
            const rowData = rows_4[indices[i]].slice();
            const concatrow = rows_4[indices[j]].splice(4);
            const duplicateRow = rowData.concat(concatrow);
            mergedData.push(duplicateRow);
          }
        }
      }
    }

    const newHead = [];
    let header_4_new = [];
    const first_elem = header_4.slice(0, 4);
    for (let n = 1; n <= ch; n++) {
      for (const h in header_4) {
        if (
          header_4[h] !== "user_id" &&
          header_4[h] !== "voucher" &&
          header_4[h] != "valid" &&
          header_4[h] != "language"
        ) {
          let num_und = 0;
          const split = header_4[h].split("_");
          for (let i = 0; i < header_4[h].length; i++) {
            if (header_4[h][i] == "_") {
              num_und++;
            }
          }

          split[num_und] = "" + n;
          header_4[h] = split.join("_");
          newHead.push(header_4[h]);
        }
      }
    }

    header_4_new = first_elem.concat(newHead);

    const mergedDataFinal = [...mergedData];

    for (const e in rows_4) {
      let contr = 0;
      for (const x in mergedData) {
        if (rows_4[e][0] == mergedData[x][0]) {
          contr = 1;
        }
      }
      if (contr == 0) {
        const len = header_4_new.length - rows_4[e].length + 4;
        const newArrayEmpty = new Array(len).fill("NULL");
        const concatrow = newArrayEmpty.splice(4);
        mergedDataFinal.push(rows_4[e].concat(concatrow));
      }
    }
    const csvData_4 = this.createCsvData(header_4_new, mergedDataFinal);

    // Create Blob objects from CSV data
    const blob_1 = this.createCsvBlob(csvData_1);
    const blob_2 = this.createCsvBlob(csvData_2);
    const blob_3 = this.createCsvBlob(csvData_3);
    const blob_4 = this.createCsvBlob(csvData_4);

    // Create download links and trigger downloads

    const emailShort = userEmail
      .substring(0, userEmail.indexOf("@"))
      .replace(/\./g, "");
    if (emailShort != "") {
      const zip = new JSZip();

      zip.file(`${emailShort}_${firstCsvName}.csv`, blob_1);
      zip.file(`${emailShort}_${secondCsvName}.csv`, blob_2);
      zip.file(`${emailShort}_${thirdCsvName}.csv`, blob_3);
      zip.file(`${emailShort}_${fourCsvName}.csv`, blob_4);
      zip.generateAsync({ type: "blob" }).then(function (content) {
        saveAs(content, `${emailShort}_${zipName}.zip`);
      });
    } else {
      const zip = new JSZip();

      zip.file(`${firstCsvName}.csv`, blob_1);
      zip.file(`${secondCsvName}.csv`, blob_2);
      zip.file(`${thirdCsvName}.csv`, blob_3);
      zip.file(`${fourCsvName}.csv`, blob_4);
      zip.generateAsync({ type: "blob" }).then(function (content) {
        saveAs(content, `${zipName}.zip`);
      });
    }
  }

  downloadCsvZip3(
    records_1,
    records_2,
    userEmail,
    zipName,
    firstCsvName,
    secondCsvName
  ) {
    // Extract header and create rows for CSV files
    const header_1 = this.extractHeader(records_1);
    records_1 = this.filter_downloadCsvZip2(records_1, userEmail);
    const rows_1 = this.createRows(records_1, header_1);
    const csvData_1 = this.createCsvData(header_1, rows_1);

    const header_2 = this.extractHeader(records_2);
    records_2 = this.filter_downloadCsvZip2(records_2, userEmail);
    const rows_2 = this.createRows(records_2, header_2);
    const csvData_2 = this.createCsvData(header_2, rows_2);

    // Create Blob objects from CSV data
    const blob_1 = this.createCsvBlob(csvData_1);
    const blob_2 = this.createCsvBlob(csvData_2);

    // Create download links and trigger downloads

    const emailShort = userEmail
      .substring(0, userEmail.indexOf("@"))
      .replace(/\./g, "");
    if (emailShort != "") {
      const zip = new JSZip();

      zip.file(`${emailShort}_${firstCsvName}.csv`, blob_1);
      zip.file(`${emailShort}_${secondCsvName}.csv`, blob_2);

      zip.generateAsync({ type: "blob" }).then(function (content) {
        saveAs(content, `${emailShort}_${zipName}.zip`);
      });
    } else {
      const zip = new JSZip();

      zip.file(`${firstCsvName}.csv`, blob_1);
      zip.file(`${secondCsvName}.csv`, blob_2);
      zip.generateAsync({ type: "blob" }).then(function (content) {
        saveAs(content, `${zipName}.zip`);
      });
    }
  }

  onType() {
    this.activeUsersShown = [];
    const textArea = document.getElementById(
      "userSearchBar"
    ) as HTMLTextAreaElement;
    const searchText = textArea.value.toLowerCase();

    for (const user of this.activeUsers) {
      if (user.email.toLowerCase().includes(searchText)) {
        this.activeUsersShown.push(user);
      }
    }
  }

  onManageAttemptUserSearch() {
    clearTimeout(this.typingTimer);
    this.typingTimer = setTimeout(() => {
      const inputElement = document.getElementById(
        "userSearch"
      ) as HTMLTextAreaElement;
      const searchText = inputElement.value.toLowerCase();

      if (searchText === "") {
        return;
      }

      this.adminService.getAttemptsList(searchText).then((data: any) => {
        this.attemptsList = data.body;
      });
    }, 500);
  }

  onFilterSelectionByTaskChange(lastSelected) {
    this.activeUsersShown = [];
    this.selectedFilterByTask = lastSelected;

    switch (this.selectedFilterByTask) {
      case "AllUsers":
        this.activeUsersShown = this.activeUsers;
        break;
      case "Voucher":
        this.activeUsersShown = this.activeUsers.filter((userA) => {
          const emailA = userA.email.replace(/_\d+$/, "");
          const isVoucherHolder = this.noVoucherUsers.every(
            (userB) => userB.email !== emailA
          );
          const isBlocked = this.isUserBlocked(emailA);
          return isVoucherHolder && !isBlocked;
        });
        break;
      case "NoVoucher":
        this.activeUsersShown = this.activeUsers.filter((userA) => {
          // Remove only attempt-suffix in the of email
          const emailA = userA.email.replace(/_\d+$/, "");
          return this.noVoucherUsers.some((userB) => userB.email === emailA);
        });
        break;
      case "Italian":
        this.activeUsersShown = this.activeUsers.filter((userA) => {
          const emailA = userA.email.replace(/_\d+$/, "");
          return this.noVoucherUsers.some(
            (userB) => userB.email === emailA && userB.nation === "IT"
          );
        });
        break;
      case "Spanish":
        this.activeUsersShown = this.activeUsers.filter((userA) => {
          const emailA = userA.email.replace(/_\d+$/, "");
          return this.noVoucherUsers.some(
            (userB) => userB.email === emailA && userB.nation === "SP"
          );
        });
        break;
    }
  }

  onSelectionChange(lastSelected) {
    this.selectedTask = lastSelected;
    this.showAttemptSelector =
      lastSelected === "FlashBeep" ||
      lastSelected === "LoudnessPerception" ||
      lastSelected === "MovementPerception" ||
      lastSelected === "TargetDetection" ||
      lastSelected === "WordCategorization";
  }

  onAttemptSelectChange(lastSelected) {
    this.selectedAttempt = lastSelected;
  }

  downloadSelectedTask() {
    switch (this.selectedTask) {
      case "Covid":
        this.downloadQuestionnaireDataAll("Covid");
        break;
      case "Demographic":
        this.downloadQuestionnaireDataAll("Demographic");
        break;
      case "Fatigue":
        this.downloadQuestionnaireDataAll("Fatigue");
        break;
      case "Personality":
        this.downloadQuestionnaireDataAll("Personality");
        break;
      case "Quality":
        this.downloadQuestionnaireDataAll("Quality");
        break;
      case "FlashBeep":
        this.downloadTaskDataAll("FlashBeep");
        break;
      case "LoudnessPerception":
        this.downloadTaskDataAll("LoudnessPerception");
        break;
      case "MovementPerception":
        this.downloadTaskDataAll("MovementPerception");
        break;
      case "TargetDetection":
        this.downloadTaskDataAll("TargetDetection");
        break;
      case "WordCategorization":
        this.downloadTaskDataAll("WordCategorization");
        break;
      case "UsersInfo":
        this.downloadUsersIdAndEmail();
        break;
      case "Charlie":
        this.downloadCharlie();
        break;
      case "FactorAnalysis":
        this.downloadFA();
        break;
      case "SeverityIndexes":
        this.downloadQuestionnaireDataAll("SeverityIndexes");
        break;
    }
  }

  manageNewData() {
    this.activeUsers = this.pooledActiveUsers;
    this.activeUsersShown = this.pooledActiveUsers;
    this.newDataAvailable = false;
    const textArea = document.getElementById(
      "userSearchBar"
    ) as HTMLTextAreaElement;
    textArea.value = "";
  }

  updateCheckboxVoucher(user_email) {
    this.adminService.checkVoucher(user_email);
  }

  isChecked(user_email, is_checked) {
    let contr = 0;
    const user_email2 = user_email.split("_")[0];
    for (const u of this.checkedUsers) {
      if (u.email == user_email2 && u.is_checked == is_checked) {
        contr = 1;
      }
    }
    return contr == 1;
  }

  isActiveUntil(user_email) {
    const threeDaysInMillis = 259200000; // Timestamp is 4 days

    for (const j in this.notifiedUsers) {
      if (this.notifiedUsers[j].email === user_email) {
        const timestamp = this.notifiedUsers[j].timestamp;
        const inputDate = new Date(timestamp);
        const activeLimit = new Date(inputDate.getTime() + threeDaysInMillis);
        return activeLimit.toISOString().split("T")[0];
      }
    }
    return "";
  }

  onTypeBlockedUsers() {
    const blockedSearch = document.getElementById(
      "blockedUserSearchBar"
    ) as HTMLTextAreaElement;
    this.blockedUsersShown = this.blockedUsers.filter((item) =>
      item.email.toLowerCase().includes(blockedSearch.value.toLowerCase())
    );
  }

  extendTime(user, time) {
    this.unblockUser(user);
    this.extendUser(user, time);
  }

  extendUser(user, time) {
    this.adminService
      .extendUser(user.email, time)
      .then(() => {})
      .catch(() => {});
  }

  unblockUser(user) {
    const confirmation = confirm(
      "Are you sure you want to perform this action?"
    );
    if (confirmation) {
      this.adminService
        .unblockUser(user.id)
        .then((result) => {
          this.blockedUsers = this.blockedUsers.filter((dict) => dict !== user);
          this.blockedUsersShown = this.blockedUsersShown.filter(
            (dict) => dict !== user
          );
        })
        .catch(() => {});
    }
  }

  handleFile(event: any) {
    const fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      this.fileToRead = fileList[0];
      this.fileName = this.fileToRead.name;
    }
  }

  processFile(action, lang) {
    if (this.fileToRead) {
      const reader = new FileReader();

      reader.onload = (e: any) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: "binary" });

        // read the first sheet in the workbook
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];

        // Convert the worksheet to an array of objects
        this.jsonData = XLSX.utils.sheet_to_json(worksheet);

        // Process Data
        switch (action) {
          case "DownloadAll":
            this.saveTranslationsJSONFiles();
            break;
          case "DownloadLang":
            this.downloadTranslation(lang);
            break;
        }
      };

      reader.readAsBinaryString(this.fileToRead);
    } else {
      console.log("No file selected.");
    }
  }

  processFileFA(action, lang) {
    if (this.fileToRead) {
      const reader = new FileReader();

      reader.onload = (e: any) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: "binary" });

        // read the first sheet in the workbook
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];

        // Convert the worksheet to an array of objects
        this.jsonData = XLSX.utils.sheet_to_json(worksheet);
        // Process Data
        this.uploadFACoefficientData();
      };
      reader.readAsBinaryString(this.fileToRead);
    } else {
      console.log("No file selected.");
    }
  }

  uploadFACoefficientData() {
    this.adminService
      .uploadFACoefficientData(this.jsonData)
      .then(() => {})
      .catch((error) => {});
  }

  async saveTranslationsJSONFiles() {
    const languages = Object.keys(this.jsonData[0]);
    languages.shift();
    const zip = new JSZip();

    for (const lang of languages) {
      const languageData = {};
      this.jsonData.forEach((item) => {
        languageData[item.Key] = item[lang];
      });
      const jsonContent = JSON.stringify(languageData, null, 4);
      zip.file(`${lang}.json`, jsonContent);
    }

    const zipBlob = await zip.generateAsync({ type: "blob" });

    // Trigger a file download in the browser
    const zipFilename = "i18n.zip";
    const anchor = document.createElement("a");
    anchor.href = window.URL.createObjectURL(zipBlob);
    anchor.download = zipFilename;
    anchor.style.display = "none";
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  }

  downloadTranslation(lang) {
    const languageData = {};
    this.jsonData.forEach((item) => {
      languageData[item.Key] = item[lang];
    });
    const jsonBlob = new Blob([JSON.stringify(languageData, null, 4)], {
      type: "application/json",
    });
    saveAs(jsonBlob, lang + ".json");
  }

  confirmCreateNewAttempt(userId: string, event: Event): void {
    const button = event.target as HTMLButtonElement;
    const confirmed = confirm("Are you sure you want to create a new attempt?");
    if (confirmed) {
      this.createNewAttempt(userId, button);
    }
  }

  createNewAttempt(userId: string, button: HTMLButtonElement) {
    button.disabled = true;
    this.adminService
      .createNewAttempt(userId)
      .then(() => {
        const inputElement = document.getElementById(
          "userSearch"
        ) as HTMLTextAreaElement;
        inputElement.value = "";
        this.attemptsList = [];

        alert("New attempt created successfully");
      })
      .catch((error) => {
        button.disabled = false;
        alert("Failed to create new attempt: " + error.error);
      });
  }
}
